import * as React from "react";

import "./Mipa.scss";
import { IMipaProps } from "./IMipaProps";
import Reports from "../components/CRMMeeting/Reports";
import PlannerTasks from "../components/PlannerTask/PlannerTasks";
import NewPlanTask from '../components/PlannerTask/newplannertask';
import MySetting from "./MySetting/MySetting";
import Events from "../components/OutlookMeeting/events";
import OutlookTaskList from "../components/OutlookTask/outlookTaskList";
import PipelineList from "../components/SSO/pipelinelist";
import FlaggedEmailItemList from "../components/FlaggedEmail/FlaggedEmailList";
import ColHeading from "../components/ColHeading/Heading";
import CalView from "../../src/components/CalView/calview";
import Moment from "react-moment";
import moment from 'moment';
import { Helper } from "../Utils/Helper";
import { MIAPACons } from "../Utils/MipaConstant";
import { GraphRequest } from "../Utils/GraphRequest";
import { ServiceRequest } from "../Utils/ServiceRequest";
import { Language } from "../Utils/Language";
import * as $ from "jquery";
import { Checkbox } from "office-ui-fabric-react/lib/Checkbox";
import Planobj from "../Entity/plan";
import CommonMessage from "./Messages/CommonMessage";
import LicExp from "./Messages/LicExp";
import LicLimitExced from "./Messages/LicLimitExced";
import Login from "./Login/Login";
import * as microsoftTeams from "@microsoft/teams-js";
import { app } from "@microsoft/teams-js";
import { initializeIcons } from "@uifabric/icons";
//import { reactAI } from "react-appinsights";
//import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { OutlookEmailobj } from "../Entity/OutlookEmailobj";
import FileItem from './RecentFile/fileitem';
import FilePagging from './RecentFile/filepaging';
import MyMIPASettingobj, { MSListItem, MSListConfig } from "../Entity/MySettingobj";
import MSListItemBlock from './MSList/MSListItemBlock';
import Loading from './Common/Loading';
import QuickViewTabs from "./QuickAccess/quickviewtabs";
import PlannerDashboard from "./PlannerTask/plannerdashboard";
import MIPAUsers from "./MySetting/mipausers";
import AdminConsent from "./Messages/AdminConsent";
import MicrosoftLicRequirement from "./Messages/microsotlicsetting";
import { DateHelper } from "../Helpers/DateHelper";

export default class Mipa extends React.Component<IMipaProps> {
  public refloading;
  public static Assigneeusers: any;
  public static GroupToken: "";

  //public serviceurl = "https://service.iglobecrm.com/IGlobeService.svc/";
  public serviceurl =window.location.protocol + "//" + window.location.host + '/api/IGService/';
  public APIServiceurl = window.location.protocol + "//" + window.location.host + "/mipa";
  public O2SURL = "https://o2sapp.iglobe.dk/Home/MailSave";
  public SRequest = new ServiceRequest();
  public email = "";
  public appurl = "";
  public sptoken = "";
  public Graphtoken = "";
  public username = "";
  public CurrentUser = null;
  public CurrentUserOrganizationId: string;
  public logtitle = '';
  public culture = "en-us";
  public overAllView = -1;
  public FromDate: Date;
  public RequestPending: Number;
  public ToDate: Date;
  public NextWeekStartDate: Date;
  public NextWeekEndDate: Date;
  public ThisWeekEndDate: Date;
  public ThisWeekStartDate: Date;
  public CalViewStartWeek: Date;
  public CalViewEndWeek: Date;
  public ClientId: String;
  public state = MIAPACons.MIPAState;

  public GraphHeader: {};
  public APIHeader: {};

  public EventPhrases = null;
  public PlannerPhrases = null;
  public SSOPhrases = null;
  public TODOPhrases = null;
  public MeetingReportPhrases = null;
  public FlaggedEmailPhrases = null;
  public ProgressIsShowing = false;
  public Renderwithmessage = false;
  public MeetingContacts;
  public SSOContacts;
  public myPlanList: Planobj[] = [];
  public flagemailfortask = null;
  public usertimezone = '';
  public haveEmailSetting = false;
  public currentplan = '';
  public IsSSOEnabled = false;
  public extpropid = 'String {66f5a359-4659-4830-9070-00040ec6ac6e} Name preperationevt';
  public NextURL = {
    myrecent: {
      nextlist: [MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyRecentFiles + '?$top=30'],
      currentpos: 0
    },
    myshared: {
      nextlist: [MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.SharedWithMe + '?$top=30'],
      currentpos: 0
    },
    myattachmnets: {
      nextlist: [MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyAttachments],
      currentpos: 0
    },
  }
  public MySettingInfo: MyMIPASettingobj;
  public mySecretaryList = [];
  public myManager = null;
  public MSlistUsers = [];
  public ShowSettingButton = false;
  public userSiteURL: string;
  public MSListAccumulated = {
    Today: new Array(),
    ThisWeek: new Array(),
    NextWeek: new Array(),
    Late: new Array()
  };
  public adminurl = "";
  public MyStickyNotes = [];
  public MyLinks = [];
  public IsMyTask = true;
  public SelectedPlanList = [];

  public constructor(props: IMipaProps) {
    super(props);
    this.RequestPending = 0;
    Mipa.Assigneeusers = new Array();
    this.CalViewStartWeek = new Date();
    this.CalViewEndWeek = new Date();
    initializeIcons();
    //this.AppInsideInitialize();
    this.refloading = React.createRef();
  }
  public AppInsideInitialize = () => {
    /*try {
      let appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: "c9b3ea36-362a-49f4-9439-72ae80381698",
          extensions: [reactAI],
          extensionConfig: {
            [reactAI.extensionId]: { debug: false }
          }
        }
      });
      appInsights.loadAppInsights();
      appInsights.trackPageView();
    } catch (ex) {
      console.error(ex);
    }*/
  }

  public render(): React.ReactElement<IMipaProps> {
     
    let Renderingview;
    /*if(window.IsMobileOperatingSystem()){
      return (
        <div id="dvmipawebpartcontainer" className="mipa">
          <div className="container">
              <div style={{marginTop:'20px',textAlign:'center',padding:'10px'}}>Accessing the CRM MIPA can only be done from a client UI</div>
          </div>
        </div>
      );
    }
   if(window.IsMobileOperatingSystem() && this.state.ErrorMessage=="Initializing..."){
     this.InitiateLoginin();
   }*/
   
    if (this.state.Dashboard == 2) {
      Renderingview = (
        <PlannerDashboard
          PlannerTask={this.state.PlannerTask}
          culture={this.culture}
          myPlanList={this.myPlanList}
          Users={this.state.GraphUsers}
          Loadpic={this.GetUserImage}
          UpdateData={this.UpdatePlannerTask}
          UserEmail={this.email}
          Language={this.culture}
          Header={this.GraphHeader}
          Phrases={this.PlannerPhrases}
          ReloadPlannerTasks={this.GetPlannerTaks}
          Progress={this.ShowHideProgress}
          ThisWeekStartDate={this.ThisWeekStartDate}
          ThisWeekEndDate={this.ThisWeekEndDate}
          NextWeekStartDate={this.NextWeekStartDate}
          NextWeekEndDate={this.NextWeekEndDate}
          GraphHeader={this.GraphHeader}
          GetPlannerTaks={this.GetPlannerTaks}
          changeplan={this.changeplan}
          HomeAction={this.GoToHome}
          APIHeader={this.APIHeader}
          APIServiceurl={this.APIServiceurl}
          CurrentUser={this.CurrentUser}
          RefreshCRMData={this.RefreshCRMData}
          TriggerReloadPlannerTasks={this.state.TriggerReloadPlannerTasksInPlannerDashboard}>
        </PlannerDashboard>);
    }
    else if (this.state.Calview <= 0 && this.overAllView != 7) {
      Renderingview = this.RenderDashboardOne();
    }
    else if (this.overAllView == 7) {
      Renderingview = this.RenderFilesDashboard();
    }
    else {
      Renderingview = this.prepareCalviewUI();
    }
    if (this.EventPhrases == null) {
      this.PrepareEventPhrases();
    }
    if (this.PlannerPhrases == null) {
      this.PreparePlannerPhrases();
    }
    if (this.SSOPhrases == null) {
      this.PrepareSSOPhrases();
    }
    if (this.TODOPhrases == null) {
      this.PrepareTODOPhrases();
    }
    if (this.MeetingReportPhrases == null) {
      this.PrepareMeetingReportPhrases();
    }
    if (this.FlaggedEmailPhrases == null) {
      this.PrepareFlaggedEmailPhrases();
    }
    let searchplaceholder = Language.GetLanguageValue(
      this.culture,
      "searchplaceholder"
    );

    if (
      this.state.ShowLogin == true ||
      this.state.ShowMessage != "" ||
      this.state.ComponetName != ""
    ) {
      this.Renderwithmessage = true;
      return this.RenderMessage();
    }
    var PageTittle = "";

    if (this.overAllView == 6) {
      PageTittle = Language.GetLanguageValue(this.culture, "activeworks");
    }
    else if (this.state.activitytitle == "") {
      PageTittle = Language.GetLanguageValue(this.culture, "useractivity");
    }
    else if (this.state.Dashboard == 2) {
      PageTittle = Language.GetLanguageValue(this.culture, "PlannerDashboard");
    }
    else {
      PageTittle = this.state.activitytitle;
    }
    if (this.props.isSetting) {
      return this.RenderSettingView();
    }
    else if (this.props.isUsers) {
      return this.RenderMangeUserView();
    }
    return (
      <div id="dvmipawebpartcontainer" className="mipa">
        {this.state.Calview > 0 ? this.RenderCalenderViewHeading() : null}
        <div className="container">
          <div className="row">
            <div className="ms-Grid">
              <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                <div className="ms-Grid-col ms-sm12 ms-lg12 ms-md12">
                  <span className="pageheading">{PageTittle}</span>


                  <span className="ms-Icon ms-Icon--Search searchcontainer">
                    <input
                      id="txtsearch"
                      type="search"
                      className="MIPAsearch"
                      placeholder={searchplaceholder}
                    />

                  </span>
                  {<Loading AbsolutePossition={true}
                    ref={refel => (this.refloading = refel)}
                  /* ref={this.refloading} */
                  />}
                  {/*  {this.state.isLoading ? (
                    <div className="mipaloading">&nbsp;</div>
                  ) : null} */}
                </div>
                {/*<div className="ms-Grid-col ms-sm12 ms-lg9 ms-md9">
                  <span className="ms-Icon ms-Icon--Search searchcontainer">
                    <input
                      id="txtsearch"
                      type="search"
                      className="MIPAsearch"
                      placeholder={searchplaceholder}
                    />

                  </span>
                   <div style={{textAlign:"right"}}>
                  <select id='ddlplans' className={plansectionclass} onChange={this.changeplan}>
                      <option value=''>My Tasks</option>
                      {
                        this.myPlanList.map((obj,index)=>{
                        return <option key={"MyplanKey_"+index} value={obj.id}>{obj.title}</option>
                        })
                      }
                    </select>
                    
                  <span className="ms-Icon ms-Icon--Search searchcontainer">
                    <input
                      id="txtsearch"
                      type="search"
                      className="MIPAsearch"
                      placeholder={searchplaceholder}
                    />
                   
                  </span>
                  
                  </div> 

                </div>*/}



              </div>
              {this.overAllView != 7 && (
                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                  {this.RenderCreateActions()}
                  <div className="ms-Grid-col ms-sm12 ms-lg7 ms-md7">
                    <ul className="actionul">
                      {this.RenderViewSwithButton()}
                    </ul>

                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg5 ms-md5">
                    {/*  {this.state.Dashboard!=2 && (this.RenderCreateActions())} */}
                    {/* {this.RenderCreateActions()} */}
                  </div>

                </div>
              )}

            </div>
            <div>
              {this.state.Dashboard == 1 ? (
                <div className="bodyfirstcol">
                  <div id="dvmipasections" className="accordion-group">
                    {this.GetSummaryCom()}
                  </div>
                </div>
              ) : null}

              <div className={this.state.Dashboard != 2 ? "bodysecondcol" : ''}>
                <div className="ms-Grid">{Renderingview}</div>
              </div>
            </div>
          </div>
        </div>
        {this.state.ShowNewPlanTaskWindow ? <NewPlanTask
          closeMethod={this.closePlantaskWindow}
          plans={this.myPlanList}
          GraphHeader={this.GraphHeader}
          Phrases={this.PlannerPhrases}
          Users={this.state.GraphUsers}
          Loadpic={this.GetUserImage}
          UserEmail={this.email}
          APIHeader={this.APIHeader}
          APIServiceurl={this.APIServiceurl}
          flagemailfortask={this.flagemailfortask}
          Updatetask={this.UpdatePlannerTask}
        /> : null}

        {
          this.state.ShowMysettingWindow ? <MySetting
            closeMethod={this.closeMysettingWindow}
            SettingInfo={this.MySettingInfo}
            GraphHeader={this.GraphHeader}
            Phrases={this.PlannerPhrases}
            UserEmail={this.email}
            SiteURL={this.userSiteURL}
            APIHeader={this.APIHeader}
            APIServiceurl={this.APIServiceurl}
            UpdateConfig={this.UpdateMsListInfo}
            Manager={this.myManager}
            SacretaryList={this.mySecretaryList}
            AdminURL={this.adminurl}
          /> : null
        }
        <span id="splicense" className="ms-fontColor-error"></span>
      </div>
    );
  }

  private RenderSettingView = () => {
    return (
      <div id="dvmipawebpartcontainer" className="mipa">
        {this.ShowSettingButton ? (
          <MySetting
            closeMethod={
              () => {

              }
            }
            SettingInfo={this.MySettingInfo}
            GraphHeader={this.GraphHeader}
            Phrases={this.PlannerPhrases}
            UserEmail={this.email}
            SiteURL={this.userSiteURL}
            APIHeader={this.APIHeader}
            APIServiceurl={this.APIServiceurl}
            UpdateConfig={() => { }}
            /* UpdateConfig={this.UpdateMsListInfo} */
            Manager={this.myManager}
            SacretaryList={this.mySecretaryList}
            AdminURL={this.adminurl}
          />
        ) :
          (<Loading ref={refel => (this.refloading = refel)} />)}
      </div>

    )
  }
  private RenderMangeUserView = () => {
    return (
      <div id="dvmipawebpartcontainer" className="mipa">

        {this.ClientId != '' ? (
          <MIPAUsers AdminURL={this.adminurl} />
        ) :
          (<Loading ref={refel => (this.refloading = refel)} />)}
      </div>

    )
  }
  private RenderDashboardOne = () => {
    return (
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md4">
          {this.RenderActivityForCol("ToDayCol", 0, "Today")}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md8">
          {this.userSiteURL != null && this.userSiteURL != '' && !window.IsMobileOperatingSystem() ? (<QuickViewTabs fnGetNotes={this.GetMIPAStickyNotes} fnSaveNotes={this.SaveMIPAStickyNote}
            fnGetLinks={this.GetMIPALinks} fnSaveLinks={this.SaveMIPALinks}
            CacheNotes={(notes) => {
              this.MyStickyNotes = notes;
            }}
            Notes={this.MyStickyNotes}
            CacheLinks={(links) => {
              this.MyLinks = links
            }}
            Links={this.MyLinks}
            culture={this.culture}
            fnGetPrev={this.GetMIPALinksPrev}
          />) : null}

        </div>
      </div>
    );
  }

  private RenderCalenderViewHeading = () => {
    return (
      <div className="calviewheading">
        {/* <i
                className="ms-Icon ms-Icon--ChromeBack"
                onClick={()=>{this.SwithtoColview(0,'useractivity')}}
                title={swithcalviewtext}
              /> */}
        <span>
          {Language.GetLanguageValue(this.culture, "week")}
          <Moment format="WW ">{this.CalViewStartWeek.toString()}</Moment>(
          <Moment format="DD MMM ">
            {this.CalViewStartWeek.toString()}
          </Moment>
          {Language.GetLanguageValue(this.culture, "to")}
          <Moment format=" DD MMM">{this.CalViewEndWeek.toString()}</Moment>
          )
        </span>
      </div>
    )
  }
  public RenderCreateActions = () => {
    if(window.IsMobileOperatingSystem()){
      return null;
    }
    
    var buttons = [];
    buttons.push(
      <span
        style={{ position: 'relative', zIndex: 1 }}
        key="Calview0"
        className="linkbutton newplantask"
        onClick={() => {

          let prevstate = { ...this.state };
          prevstate.TriggerReloadPlannerTasksInPlannerDashboard = true;
          this.ChangeState(prevstate);
          this.flagemailfortask = null;
          this.shownewtaskwindow();
        }}
        title={Language.GetLanguageValue(this.culture, "newplantask")}
      >
        <i className="ms-Icon ms-Icon--Add"></i> {Language.GetLanguageValue(this.culture, "addtask")}
      </span>

    );
    return buttons;
  }
  public RenderViewSwithButton = () => {
    var buttons = [];
    var view = this.state.Calview;
    let buttoncell = "";

    if (this.state.Dashboard != 2) {
      if (this.state.Calview == 1 || this.state.Calview == 2) {
        buttons.push(
          <li className={buttoncell}>
            <button
              key="plannerdashboard"
              onClick={this.GoToHome}
              className="viewswitchbtn weekaction homeaction"
            >
              <i className="ms-Icon ms-Icon--HomeSolid"></i>
              {Language.GetLanguageValue(this.culture, "Home")}
            </button>
          </li>
        );
      }
     /*  buttons.push(
        <li className={buttoncell} key="li-plannerdashboard">
          <button
            key="plannerdashboard"
            onClick={() => {
              let prevstate = { ...this.state };
              prevstate.Dashboard = 2;
              prevstate.activitytitle = Language.GetLanguageValue(this.culture, 'plannertask');
              this.ChangeState(prevstate);
            }}
            className="viewswitchbtn plannertask weekaction">
            <i className="ms-Icon ms-Icon--PlannerLogo "></i>
            {Language.GetLanguageValue(this.culture, "PlannerDashboard")}
          </button>
        </li>

      ); */
    }
    //if (view != 1 && this.state.Dashboard != 2) {
    if (this.state.Dashboard != 2) {
      if (this.state.Calview == -1 || this.state.Calview == 0) {
        buttons.push(
          <li className={buttoncell} key="li-Calview1">
            <button
              key="Calview1"
              onClick={() => {
                if (view != 1) {
                  this.SwithtoColview(0, "useractivity");
                }

              }}
              className={view == 0 ? "weekaction weekbtnselected viewswitchbtn" : "weekaction viewswitchbtn"}

            >
              <i className="ms-Icon ms-Icon--CalendarWeek"></i>
              {Language.GetLanguageValue(this.culture, "today")}
            </button>
          </li>

        );

        buttons.push(
          <li className={buttoncell} key="li-callview1.1">
            <button
              key="Calview1"
              onClick={() => {
                if (view != 1) {
                  this.SwithtoColview(-1, "userlateactivity");
                }

              }}
              className={view == -1 ? "weekaction weekbtnselected viewswitchbtn" : "weekaction viewswitchbtn"}

            >
              <i className="ms-Icon ms-Icon--CalendarWeek"></i>
              {Language.GetLanguageValue(this.culture, "Late")}
            </button>
          </li>

        );
      }
      buttons.push(
        <li className={buttoncell} key="li-calview1.2">
          <button
            key="Calview1"
            onClick={() => {
              if (view != 1) {
                this.SwithtoColview(1, "thisweekactivity");
              }

            }}
            className={view == 1 ? "weekaction weekbtnselected viewswitchbtn" : "weekaction viewswitchbtn"}

          >
            <i className="ms-Icon ms-Icon--CalendarWeek"></i>
            {Language.GetLanguageValue(this.culture, "thisweek")}
          </button>
        </li>

      );
    }
    //if (view != 2 && this.state.Dashboard != 2) {
    if (this.state.Dashboard != 2) {
      buttons.push(
        <li className={buttoncell} key="li-calview2">
          <button
            key="Calview2"
            onClick={() => {
              if (view != 2) {
                this.SwithtoColview(2, "nextweekactivity");
              }

            }}
            className={view == 2 ? "weekaction weekbtnselected viewswitchbtn" : "weekaction viewswitchbtn"}

          >
            <i className="ms-Icon ms-Icon--CalendarWeek"></i>
            {Language.GetLanguageValue(this.culture, "nextweek")}
          </button>
        </li>

      );
    }
    if (view > 0 && this.state.Dashboard != 2) {
      buttons.push(
        <li className={buttoncell} key="li-calview3">
          <button
            key="Calview3"
            onClick={() => {
              this.setState({ showweekend: !this.state.showweekend });
            }}
            className="weekaction viewswitchbtn weekendbtn"
          >
            {this.state.showweekend ? (
              <i
                className="ms-Icon ms-Icon--Accept x-hidden-focus"
                style={{ color: "green", marginRight: "3px" }}
              />
            ) : (
              <i
                className="ms-Icon ms-Icon--Cancel x-hidden-focus"
                style={{ color: "red", marginRight: "3px" }}
              />
            )}
            {Language.GetLanguageValue(this.culture, "showweekend")}
          </button>
        </li>

      );
    }
    
    return buttons;
  };
  public RenderMessage = () => {
    if (this.state.ShowLogin) {
      return (
        <div id="dvmipawebpartcontainer" className="mipa">
          <Login
            appurl={this.APIServiceurl}
            email={this.email}
            clientid={this.ClientId}
          />
        </div>
      );
    } else if (this.state.ShowMessage != "") {
      return (
        <div id="dvmipawebpartcontainer" className="mipa">
          <CommonMessage Message={this.state.ShowMessage} />
        </div>
      );
    } else if (this.state.ComponetName == "LicExp ") {
      return (
        <div id="dvmipawebpartcontainer" className="mipa">
          <LicExp />
        </div>
      );
    } else if (this.state.ComponetName == "LicLimitExced") {
      return (
        <div id="dvmipawebpartcontainer" className="mipa">
          <LicLimitExced adminemail={this.state.AdminEmail} />
        </div>
      );
    }
    else if (this.state.ComponetName == "AdminConsent") {
      return (
        <div id="dvmipawebpartcontainer" className="mipa">
          <AdminConsent />
        </div>
      );
    } else if (this.state.ComponetName == "MicrosoftLicRequirement") {
      return (
        <div id="dvmipawebpartcontainer" className="mipa">
          <MicrosoftLicRequirement />
        </div>
      );
    }
    return <LicExp />;
  };
  public PrepareEventPhrases = () => {
    this.EventPhrases = {
      title: Language.GetLanguageValue(this.culture, "meeting"),
      start: Language.GetLanguageValue(this.culture, "start"),
      end: Language.GetLanguageValue(this.culture, "end"),
      organizer: Language.GetLanguageValue(this.culture, "organizer"),
      location: Language.GetLanguageValue(this.culture, "location"),
      //edit: Language.GetLanguageValue(this.culture, "edit"),
      edit: 'Open and edit the Calendar entry in your web mail',
      bookpreperationheading: Language.GetLanguageValue(this.culture, "bookpreperationheading"),
      book15minbefor: Language.GetLanguageValue(this.culture, "book15minbefor"),
      book30minbefor: Language.GetLanguageValue(this.culture, "book30minbefor"),
      bookbutton: Language.GetLanguageValue(this.culture, "bookbutton"),
      book15minbooked: Language.GetLanguageValue(this.culture, "book15minbooked"),
      book30minbooked: Language.GetLanguageValue(this.culture, "book30minbooked"),
      bookeventsubject: Language.GetLanguageValue(this.culture, "bookeventsubject"),
      outlookeventattending: Language.GetLanguageValue(this.culture, "outlookeventattending"),
      outlookeventinvited: Language.GetLanguageValue(this.culture, "outlookeventinvited"),
      outlookeventTentative: Language.GetLanguageValue(this.culture, "outlookeventTentative"),
      outlookeventDeclined: Language.GetLanguageValue(this.culture, "outlookeventDeclined"),
      outlookeventnoresponse: Language.GetLanguageValue(this.culture, "outlookeventnoresponse"),
      outlookeventnoattendee: Language.GetLanguageValue(this.culture, "outlookeventnoattendee"),
      outlookaccepted: Language.GetLanguageValue(this.culture, "outlookaccepted"),
      outlookeventresponse: Language.GetLanguageValue(this.culture, "outlookeventresponse"),
      outlookeventresponseyes: Language.GetLanguageValue(this.culture, "outlookeventresponseyes"),
      outlookeventresponseno: Language.GetLanguageValue(this.culture, "outlookeventresponseno"),
      recentactivity: Language.GetLanguageValue(this.culture, "recentactivity"),
      desctrictioncaption: Language.GetLanguageValue(this.culture, "desctrictioncaption"),
      meetingreport: Language.GetLanguageValue(this.culture, "meetingreport"),
      opportunity: Language.GetLanguageValue(this.culture, "opportunity"),
      cancel: Language.GetLanguageValue(this.culture, "cancel"),
      showattachments: Language.GetLanguageValue(this.culture, "showattachments"),
      hideattachments: Language.GetLanguageValue(this.culture, "hideattachments")
    };
  }
  public PreparePlannerPhrases = () => {
    this.PlannerPhrases = {
      title: Language.GetLanguageValue(this.culture, "plannertask"),
      edit: Language.GetLanguageValue(this.culture, "edit"),
      start: Language.GetLanguageValue(this.culture, "start"),
      due: Language.GetLanguageValue(this.culture, "due"),
      showcomments: Language.GetLanguageValue(this.culture, "showcomments"),
      completedcount: Language.GetLanguageValue(this.culture, "completedcount"),
      attachmentcount: Language.GetLanguageValue(
        this.culture,
        "attachmentcount"
      ),
      commentscount: Language.GetLanguageValue(this.culture, "commentscount"),
      notstarted: Language.GetLanguageValue(this.culture, "notstarted"),
      completed: Language.GetLanguageValue(this.culture, "completed"),
      inprogress: Language.GetLanguageValue(this.culture, "inprogress"),
      setduedate: Language.GetLanguageValue(this.culture, "setduedate"),
      markcomplete: Language.GetLanguageValue(this.culture, "markcomplete"),
      assigned: Language.GetLanguageValue(this.culture, "assigned"),
      unassigned: Language.GetLanguageValue(this.culture, "unassigned"),
      assignto: Language.GetLanguageValue(this.culture, "assignto"),
      remove: Language.GetLanguageValue(this.culture, "remove"),
      promotitem: Language.GetLanguageValue(this.culture, "promotitem"),
      removecheckitem: Language.GetLanguageValue(
        this.culture,
        "removecheckitem"
      ),
      urgent: Language.GetLanguageValue(this.culture, "urgent"),
      important: Language.GetLanguageValue(this.culture, "important"),
      medium: Language.GetLanguageValue(this.culture, "medium"),
      low: Language.GetLanguageValue(this.culture, "low"),
      edittaskdescription: Language.GetLanguageValue(this.culture, "edittaskdescription"),
      save: Language.GetLanguageValue(this.culture, "save"),
      newplantask: Language.GetLanguageValue(this.culture, "newplantask"),
      plancaption: Language.GetLanguageValue(this.culture, "plancaption"),
      selectplan: Language.GetLanguageValue(this.culture, "selectplan"),
      tasktitlecaption: Language.GetLanguageValue(this.culture, "tasktitlecaption"),
      textplaceholder: Language.GetLanguageValue(this.culture, "textplaceholder"),
      bucket: Language.GetLanguageValue(this.culture, "bucket"),
      selectbucket: Language.GetLanguageValue(this.culture, "selectbucket"),
      progress: Language.GetLanguageValue(this.culture, "progress"),
      selecttaskstatus: Language.GetLanguageValue(this.culture, "selecttaskstatus"),
      showoncard: Language.GetLanguageValue(this.culture, "showoncard"),
      desctrictioncaption: Language.GetLanguageValue(this.culture, "desctrictioncaption"),
      addattachment: Language.GetLanguageValue(this.culture, "addattachment"),
      cancel: Language.GetLanguageValue(this.culture, "cancel"),
      addresscaption: Language.GetLanguageValue(this.culture, "addresscaption"),
      addressplaceholder: Language.GetLanguageValue(this.culture, "addressplaceholder"),
      linkalisecaption: Language.GetLanguageValue(this.culture, "linkalisecaption"),
      linkaliseplaceholder: Language.GetLanguageValue(this.culture, "linkaliseplaceholder"),
      linkvalidationreq: Language.GetLanguageValue(this.culture, "linkvalidationreq"),
      linkvalidationvalid: Language.GetLanguageValue(this.culture, "linkvalidationvalid"),
      linkalisevalidationreq: Language.GetLanguageValue(this.culture, "linkalisevalidationreq"),
      checklist: Language.GetLanguageValue(this.culture, "checklist"),
      planselectvalidaiton: Language.GetLanguageValue(this.culture, "planselectvalidaiton"),
      tasktitlevalidaiton: Language.GetLanguageValue(this.culture, "tasktitlevalidaiton"),
      bucketvalidation: Language.GetLanguageValue(this.culture, "bucketvalidation"),
      taskassigneevalidation: Language.GetLanguageValue(this.culture, "taskassigneevalidation"),
      attachfile: Language.GetLanguageValue(this.culture, "attachfile"),
      attachlink: Language.GetLanguageValue(this.culture, "attachlink"),
      attachmail: Language.GetLanguageValue(this.culture, "attachmail"),
      addchecklist: Language.GetLanguageValue(this.culture, "addchecklist"),
      priority: Language.GetLanguageValue(this.culture, "priority"),
    };
  }
  public PrepareSSOPhrases = () => {
    this.SSOPhrases = {
      title: Language.GetLanguageValue(this.culture, "opportunity"),
      //edit: Language.GetLanguageValue(this.culture, "edit"),
      edit: 'Open and edit the SSO in iGlobe CRM',
      savelog: Language.GetLanguageValue(this.culture, "savelog"),
      setfollowupdate: Language.GetLanguageValue(
        this.culture,
        "setfollowupdate"
      ),
      probability: Language.GetLanguageValue(this.culture, "probability"),
      expectedclouser: Language.GetLanguageValue(
        this.culture,
        "expectedclouser"
      ),
      potential: Language.GetLanguageValue(this.culture, "potential")
    };
  };
  public PrepareTODOPhrases = () => {
    this.TODOPhrases = {
      title: Language.GetLanguageValue(this.culture, "todo"),
      edit: Language.GetLanguageValue(this.culture, "edit"),
      start: Language.GetLanguageValue(this.culture, "start"),
      setduedate: Language.GetLanguageValue(this.culture, "setduedate"),
      status: Language.GetLanguageValue(this.culture, "status"),
      importance: Language.GetLanguageValue(this.culture, "importance"),
      markcomplete: Language.GetLanguageValue(this.culture, "markcomplete"),
      sensitivity: Language.GetLanguageValue(this.culture, "sensitivity")
    };
  };
  public PrepareMeetingReportPhrases = () => {
    this.MeetingReportPhrases = {
      title: Language.GetLanguageValue(this.culture, "meetingreport"),
      //edit: Language.GetLanguageValue(this.culture, "edit"),
      edit: 'Open and edit the meeting report in iGlobe CRM',
      savesummary: Language.GetLanguageValue(this.culture, "savesummary"),
      markcomplete: Language.GetLanguageValue(this.culture, "markcomplete"),
      setfollowupdate: Language.GetLanguageValue(
        this.culture,
        "setfollowupdate"
      ),
      reportdate: Language.GetLanguageValue(this.culture, "reportdate"),
      contacttype: Language.GetLanguageValue(this.culture, "contacttype"),
      company: Language.GetLanguageValue(this.culture, "company"),
      contact: Language.GetLanguageValue(this.culture, "contact"),
      summary: Language.GetLanguageValue(this.culture, "summary"),
      customersatisfaction: Language.GetLanguageValue(
        this.culture,
        "customersatisfaction"
      ),
      economictrends: Language.GetLanguageValue(this.culture, "economictrends"),
      followupdate: Language.GetLanguageValue(this.culture, "followupdate"),
      additionalcontact: Language.GetLanguageValue(
        this.culture,
        "additionalcontact"
      )
    };
  };
  public PrepareFlaggedEmailPhrases = () => {
    this.FlaggedEmailPhrases = {
      title: Language.GetLanguageValue(this.culture, "flaggedemail"),
      from: Language.GetLanguageValue(this.culture, "mailfrom"),
      category: Language.GetLanguageValue(this.culture, "category"),
      markcomplete: Language.GetLanguageValue(this.culture, "markcomplete"),
      setfollowupdate: Language.GetLanguageValue(this.culture, "setduedate"),
      startdate: Language.GetLanguageValue(this.culture, "start"),
      importance: Language.GetLanguageValue(this.culture, "importance")
    };
  };
  public prepareCalviewUI = () => {
    let calcrmmeeting = new Array();
    let calSSO = new Array();
    let caltodos = new Array();
    let calplannertask = new Array();
    let caloutlookevents = new Array();
    let calflaggedEmails = new Array();
    let msListData = new Array();
    let emptymessage = "";
    if (this.state.Calview == 1) {
      emptymessage = "Looks like you have a slow week. You have no activities this week";
      //calcrmmeeting = calcrmmeeting.concat(this.state.Meetings.Today);
      calcrmmeeting = calcrmmeeting.concat(this.state.Meetings.ThisWeek);

      //calSSO = calSSO.concat(this.state.SSO.Today);
      calSSO = calSSO.concat(this.state.SSO.ThisWeek);

      //caltodos = caltodos.concat(this.state.TODOS.Today);
      caltodos = caltodos.concat(this.state.TODOS.ThisWeek);

      //calplannertask = calplannertask.concat(this.state.PlannerTask.Today);
      calplannertask = calplannertask.concat(this.state.PlannerTask.ThisWeek);

      //caloutlookevents = caloutlookevents.concat(this.state.Events.Today);
      caloutlookevents = caloutlookevents.concat(this.state.Events.ThisWeek);

      //calflaggedEmails = calflaggedEmails.concat(this.state.FlaggedEmail.Today);
      calflaggedEmails = calflaggedEmails.concat(this.state.FlaggedEmail.ThisWeek);

      //msListData = msListData.concat(this.state.MSList.Today);
      msListData = msListData.concat(this.state.MSList.ThisWeek);

      this.CalViewStartWeek = this.ThisWeekStartDate;
      this.CalViewEndWeek = DateHelper.GetDateStringInZeroHours(this.ThisWeekEndDate);
    }
    else if (this.state.Calview == 2) {

      emptymessage = "Looks like you have a slow next week. You have no activities next week";
      calcrmmeeting = calcrmmeeting.concat(this.state.Meetings.NextWeek);
      calSSO = calSSO.concat(this.state.SSO.NextWeek);
      caltodos = caltodos.concat(this.state.TODOS.NextWeek);
      calplannertask = calplannertask.concat(this.state.PlannerTask.NextWeek);
      caloutlookevents = caloutlookevents.concat(this.state.Events.NextWeek);
      calflaggedEmails = calflaggedEmails.concat(this.state.FlaggedEmail.NextWeek);
      msListData = msListData.concat(this.state.MSList.NextWeek);

      this.CalViewStartWeek = this.NextWeekStartDate;
      this.CalViewEndWeek = DateHelper.GetDateStringInZeroHours(this.NextWeekEndDate);
    }

    this.CalViewEndWeek.setDate(this.CalViewEndWeek.getDate() - 1);
    return (
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CalView
            crmmeetings={calcrmmeeting}
            ssos={calSSO}
            todos={caltodos}
            plannertasks={calplannertask}
            outlookevents={caloutlookevents}
            week={this.state.Calview}
            startdate={this.CalViewStartWeek}
            Header={this.GraphHeader}
            Users={this.state.GraphUsers}
            Loadpic={this.GetUserImage}
            PlannerUpdateData={this.UpdatePlannerTask}
            ReloadPlannerTasks={this.GetPlannerTaks}
            Phases={this.state.SSO.Phases}
            Probability={this.state.SSO.Probability}
            SSOUpdateMethod={this.UpdateCRMData}
            /* LogTitle={this.state.SSO.LogTitle} */
            LogTitle={this.logtitle}
            extpropid={this.extpropid}
            CreateOrCancelPreperationEvent={this.CreateOrCancelPreperationEvent}
            UpdateEvent={this.UpdateEvent}
            AcceptEvent={this.AcceptEvent}
            Getcrmdataforrecent={this.Getcrmdataforrecent}
            PrepareContactCRMReportUI={this.PrepareMeetingReportThumbForContacts}
            PrepareContactCRMSSOUI={this.PrepareCRMSSOUIThumbForContact}
            GetCRMContactCompany={this.GetCRMContactCompany}
            GetContactRelatedMails={this.GetContactRelatedMails}
            GetOutlookemailAttachments={this.GetOutlookemailAttachments}
            CRMMeetingUpdateMethod={this.UpdateCRMData}
            UpdateToDoItem={this.UpdateToDoItem}
            UpdatePlannerTask={this.UpdatePlannerTask}
            UserEmail={this.email}
            Language={this.culture}
            InsideCRM={!this.props.isteam}
            CRMURL={this.appurl}
            eventphrases={this.EventPhrases}
            plannertaskphrases={this.PlannerPhrases}
            SSOPhrases={this.SSOPhrases}
            TODOPhrases={this.TODOPhrases}
            MeetingReportPhrases={this.MeetingReportPhrases}
            Progress={this.ShowHideProgress}
            OverAllFilter={this.overAllView}
            showweekend={this.state.showweekend}
            meetingcontacts={this.MeetingContacts}
            ssocontacts={this.SSOContacts}

            flagedemailPhrases={this.FlaggedEmailPhrases}
            flaggedemailupdate={this.UpdateFlageEmail}
            flaggedemails={calflaggedEmails}
            taskfromflagemail={this.taskfromflagemail}
            usertimezone={this.usertimezone}

            MySetting={this.MySettingInfo}
            MSListUpdateMethod={this.UpdateMSListItem}
            MSListUsers={this.MSlistUsers}
            MSListItems={msListData}

            APIHeader={this.APIHeader}
            APIServiceurl={this.APIServiceurl}

            EmptyMessage={emptymessage}
            CurrentUser={this.CurrentUser}

            RefreshCRMData={this.RefreshCRMData}
          />
        </div>
      </div>
    );
  };
  public GetMeetingscom = meeting => {
    if (meeting && meeting.length > 0) {
      return (
        <Reports
          meetings={meeting}
          UpdateMethod={this.UpdateCRMData}
          /* LogTitle={this.state.SSO.LogTitle} */
          LogTitle={this.logtitle}
          InsideCRM={!this.props.isteam}
          CRMURL={this.appurl}
          Phrases={this.MeetingReportPhrases}
          Progress={this.ShowHideProgress}
          meetingcontacts={this.MeetingContacts}
          RefreshCRMData={this.RefreshCRMData}
        />
      );
    } else {
      return "";
    }
  };
  public GetPipelinescom = SSOList => {
    if (SSOList && SSOList.length > 0) {
      return (
        <PipelineList
          Piplelines={SSOList}
          Phases={this.state.SSO.Phases}
          Probability={this.state.SSO.Probability}
          UpdateMethod={this.UpdateCRMData}
          /* LogTitle={this.state.SSO.LogTitle} */
          LogTitle={this.logtitle}
          InsideCRM={!this.props.isteam}
          CRMURL={this.appurl}
          Phrases={this.SSOPhrases}
          ssocontacts={this.SSOContacts}
          RefreshCRMData={this.RefreshCRMData}
        />
      );
    } else {
      return "";
    }
  }
  public GetPlanerTaskscom = tasks => {
    if (tasks && tasks.length > 0) {
      let key = (new Date()).toISOString();
      return (
        <PlannerTasks
          tasks={tasks}
          key={key}
          Users={this.state.GraphUsers}
          Loadpic={this.GetUserImage}
          UpdateData={this.UpdatePlannerTask}
          UserEmail={this.email}
          Language={this.culture}
          Header={this.GraphHeader}
          Phrases={this.PlannerPhrases}
          ReloadPlannerTasks={this.GetPlannerTaks}
          Progress={this.ShowHideProgress}
          APIHeader={this.APIHeader}
          APIServiceurl={this.APIServiceurl}
          CurrentUser={this.CurrentUser}
        />
      );
    } else {
      return "";
    }
  };
  public GetOutlookTaskscom = tasks => {
    if (tasks && tasks.length > 0) {
      return (
        <OutlookTaskList
          data={tasks}
          UpdateToDoItem={this.UpdateToDoItem}
          Phrases={this.TODOPhrases}
          usertimezone={this.usertimezone}
        />
      );
    } else {
      return "";
    }
  }
  public GetOutlookEventscom = eventList => {
    if (eventList && eventList.length > 0) {
      return (<Events
        events={eventList}
        phrases={this.EventPhrases}
        extpropid={this.extpropid}
        UpdateEvent={this.UpdateEvent}
        CreateOrCancelPreperationEvent={this.CreateOrCancelPreperationEvent}
        AcceptEvent={this.AcceptEvent}
        Getcrmdataforrecent={this.Getcrmdataforrecent}
        PrepareContactCRMReportUI={this.PrepareMeetingReportThumbForContacts}
        PrepareContactCRMSSOUI={this.PrepareCRMSSOUIThumbForContact}
        GetCRMContactCompany={this.GetCRMContactCompany}
        GetContactRelatedMails={this.GetContactRelatedMails}
        GetOutlookemailAttachments={this.GetOutlookemailAttachments}
        currentuseremail={this.email}
      />);
    } else {
      return "";
    }
  }
  public GetFlaggedEmails = flaggedemaillist => {
    if (flaggedemaillist && flaggedemaillist.length > 0) {
      return (
        <FlaggedEmailItemList
          flaggedemails={flaggedemaillist}
          Phrases={this.FlaggedEmailPhrases}
          UpdateMethod={this.UpdateFlageEmail}
          taskfromflagemail={this.taskfromflagemail}
          usertimezone={this.usertimezone}
        />
      );
    } else {
      return "";
    }
  }
  public GetMSListWebpart = (mslistitems: Array<MSListItem>) => {
    let webparts = [];
    mslistitems.map((item, index) => {
      let listinfo = this.MySettingInfo.ListInfo.filter((l) => { return l.SiteURL == item.SiteUrl && l.ListTitle == item.ListTitle })[0];
      let key = "mspart_Col_" + item.Col + "_" + index;
      webparts.push(
        <MSListItemBlock key={key}
          ListInfo={listinfo}
          ListItem={item}
          UserEmail={this.email}
          Users={this.MSlistUsers[listinfo.ID]}
          UpdateMethod={this.UpdateMSListItem}
        >

        </MSListItemBlock>
      );
    });
    return webparts;
  }
  public UpdateMSListItem = (config, fieldvalue) => {
    var api =
      "/UpdateMicrosoftListData";
    let objRequest = {
      config: config,
      field: fieldvalue
    };

    this.SRequest.Post(
      this.APIServiceurl,
      api,
      objRequest,
      (successres) => {
        if (successres && successres.data && successres.data.IsSuccess) {
          this.UpdateMsListInfo(null, true);
        }
      },
      (errorres) => {

        console.log(errorres);
      },
      this.ShowHideProgress,
      this.APIHeader
    );
  }
  public UpdateMsListInfo = (newconfig, refreshdata) => {
    if (newconfig != null) {
      this.MySettingInfo = newconfig;
    }
    if (refreshdata) {
      this.ResetMSListData();
      this.GetMSListData();
    }
  }
  private ResetMSListData = () => {
    let prevstate = { ...this.state };
    prevstate.MSList = {
      Today: new Array(),
      ThisWeek: new Array(),
      NextWeek: new Array(),
      Late: new Array()
    };
    prevstate.ToDayCol.MSList = 0;
    prevstate.ThisWeekCol.MSList = 0;
    prevstate.NextWeekCol.MSList = 0;
    //prevstate.ColViewTotal.TotalMSList = 0;
    prevstate.TodayTotal.TotalMSList = 0;
    prevstate.ThisWeekTotal.TotalMSList = 0;
    prevstate.NextWeekTotal.TotalMSList = 0;
    prevstate.LateTotal.TotalMSList = 0;
    this.ChangeState(prevstate);
  }
  public GetSummaryCom = () => {
    let comlist = [];

    let bagecss = [
      { background: "#2f752e" },
      { background: "#0098d9" },
      { background: "#da8009" },
      { background: "#8A41A5" },
      { background: "#376e86" },
      { background: "#FF9198" },
      //{ background: "#d55555" },
     // { background: "transparent" },

    ];
    let ICLASS = [
      "ms-Icon ms-Icon--PlannerLogo mipaactionI mipaverticalmiddle notformbile",
      "ms-Icon ms-Icon--Calendar mipaactionI mipaverticalmiddle notformbile",
      "ms-Icon ms-Icon--AddGroup mipaactionI mipaverticalmiddle",
      "ms-Icon ms-Icon--ConstructionCone mipaactionI mipaverticalmiddle",
      "ms-Icon ms-Icon--TaskLogo mipaactionI mipaverticalmiddle notformbile",
      "ms-Icon ms-Icon--Flag mipaactionI mipaverticalmiddle notformbile",
      //"ms-Icon ms-Icon--News mipaactionI mipaverticalmiddle",
     // "ms-Icon ms-Icon--DocumentSet mipaverticalmiddle",

    ];

    let ICSS = [
      { fontSize: "18px", color: "#2f752e" },
      { fontSize: "18px", color: "#0098d9" },
      { fontSize: "18px", color: "#da8009" },
      { fontSize: "18px", transform: "rotate(180deg)", color: "#8A41A5" },
      { fontSize: "18px", color: "#376e86" },
      { fontSize: "18px", color: "#FF9198" },
      //{ fontSize: "18px", color: "#d55555" },
      //{ fontSize: "18px", color: "rgb(22 152 140)", marginLeft: '15px' },
    ];
    if (this.currentplan != '') {
      ICSS[0].color = '#85ef84';
    }
    let viewmodes = [
      "plannerview",
      "outlookeventview",
      "meetingreportview",
      "pipelineview",
      "outlooktodoview",
      "outlookflagmailview",
      //"MSList",
      //"recentfileview",

    ];
    let viwcount =
      this.state.Calview == 2
        ? this.state.NextWeekTotal
        : this.state.Calview == 1
          ? this.state.ThisWeekTotal
          : this.state.Calview == 0 ? this.state.TodayTotal
            : this.state.LateTotal;
    let countvalues = [
      viwcount.TotalPlannerTask,
      viwcount.TotalEvents,
      viwcount.TotalMeeting,
      viwcount.TotalSSO,
      viwcount.TotalTODOS,
      viwcount.TotalFlaggedEmail,
      viwcount.TotalMSList,
      '',

    ];
    let LetActionLength = ICSS.length;
    /*if(this.state.Dashboard==1){
      LetActionLength--;
    }*/
    for (var index = 0; index < LetActionLength; index++) {
      if(ICLASS[index].indexOf('notformbile')>-1 && window.IsMobileOperatingSystem()){
        continue;
      }
      var headercss = { backgroundColor: "#fff" };

      if (
        this.appurl == null ||
        (this.appurl == "" && (index == 3 || index == 2))
      ) {
        continue;
      } else if (index == 6 &&
        (this.MySettingInfo == null ||
          this.MySettingInfo.ListInfo.length == 0)
      ) {
        continue;
      }
      if (this.overAllView == index) {
        headercss = { backgroundColor: "#eee" };
      }
      let leftmenuItem = (
        <header
          key={index}
          onClick={this.SetOverallFilter}
          data-index={index}
          style={headercss}
          data-viewmode={viewmodes[index]}
          className="accordion-group__accordion-head boxwithshadow"
          data-container="mytaskscontainer"
        >
          <i className={ICLASS[index]} style={ICSS[index]} />
          {countvalues[index] == -1 ? (<span style={{ float: 'right', marginTop: '-27px' }} className='mipaloading'>&nbsp;</span>) : (
            <span className="badge mipaverticalmiddle" style={bagecss[index]}>
              {countvalues[index]}
            </span>
          )}

          <div style={{ display: "none" }}>
            <Checkbox className="checkbox" />
          </div>
        </header>
      );
      if(this.haveEmailSetting===false && ["outlookeventview", "outlooktodoview", "outlookflagmailview"].indexOf(viewmodes[index])>-1){
        continue;
      }
      comlist.push(leftmenuItem);
    }

    return comlist;
  }
  public GetFilesUI = (files, isrecent, loadnext, currentpos, totalpage) => {
    let comlist = [];
    files.map((file, index) => {
      comlist.push(
        <FileItem
          fileitem={file}
          IsRecent={isrecent}
          GetThumbnailImage={this.GetThumbnailImage}
          GetFilePreview={this.GetFilePreview}
          SaveO2SFileInfo={this.SaveO2SFileInfo}
        />);
    });
    return (
      <React.Fragment>
        <div className="ms-Grid-row">{comlist}</div>
        <FilePagging pagedataload={loadnext} currentpos={currentpos} lastpageno={totalpage} />
      </React.Fragment>

    );
  }
  public SetOverallFilter = arg => {
    let index = arg.currentTarget.dataset["index"];
    if (this.overAllView == index) {
      this.overAllView = -1;
    } else {
      this.overAllView = index;
    }
    let prevstate = { ...this.state };
    prevstate.ToDayCol.currentselection = MIAPACons.MenuOption.options.slice();
    prevstate.ThisWeekCol.currentselection = MIAPACons.MenuOption.options.slice();
    prevstate.NextWeekCol.currentselection = MIAPACons.MenuOption.options.slice();
    this.ChangeState(prevstate);
  }
  public RenderThreeColumnActivityDashboard = () => {
    let colprops = ["ToDayCol", "ThisWeekCol", "NextWeekCol"];
    let dayprops = ["Today", "ThisWeek", "NextWeek"];

    return (
      <div className="ms-Grid-row">
        {colprops.map((prop, keyindex) => {
          let Daypropval = dayprops[keyindex];
          return this.RenderActivityForCol(prop, keyindex, Daypropval);

        })}

      </div>
    );
  }
  private RenderActivityForCol = (prop, keyindex, Daypropval) => {
    let view = this.state.Calview;
    Daypropval = view == 0 ? "Today" : "Late"
    let showMeeting =
      this.overAllView < 0 || this.overAllView == 2 ? true : false;
    let showsso = this.overAllView < 0 || this.overAllView == 3 ? true : false;
    let showplannertask =
      this.overAllView < 0 || this.overAllView == 0 ? true : false;
    let showevents =
      this.overAllView < 0 || this.overAllView == 1 ? true : false;
    let showtodo = this.overAllView < 0 || this.overAllView == 4 ? true : false;
    let showflagedemail =
      this.overAllView < 0 || this.overAllView == 5 ? true : false;

    let showMSListItem = this.overAllView < 0 || this.overAllView == 6 ? true : false;
    let colclass = 'ms-Grid-col ms-sm12 ms-lg4';
    if (this.state.Dashboard == 1) {
      colclass = 'ms-Grid-col ms-sm12';
    }
    let totalitemfound = (showMeeting ? this.state.Meetings[Daypropval].length : 0) +
      (showtodo ? this.state.TODOS[Daypropval].length : 0) +
      (showsso ? this.state.SSO[Daypropval].length : 0) + (showplannertask ? this.state.PlannerTask[Daypropval].length : 0) +
      (showevents ? this.state.Events[Daypropval].length : 0) + (showflagedemail ? this.state.FlaggedEmail[Daypropval].length : 0) +
      (showMSListItem ? this.MSListAccumulated[Daypropval].length : 0);
    //totalitemfound=0;
    let DataValues = this.state[prop];
    DataValues.title = Daypropval;
    return (
      <div
        key={"Colview_" + keyindex}
        className={colclass}
      >
        <ColHeading
          data={DataValues}
          changeview={this.FilterColData}
          language={this.culture}
          options={this.state[prop].currentselection}
          overAllView={this.overAllView}
        />
        {totalitemfound == 0 && (<span className="emptymessageblock">Looks like you have a slow day today.</span>)}
        {this.state[prop].currentselection.indexOf("Meetings") >= 0 &&
          showMeeting
          ? this.GetMeetingscom(this.state.Meetings[Daypropval])
          : null}
        {this.state[prop].currentselection.indexOf("SSO") >= 0 && showsso
          ? this.GetPipelinescom(this.state.SSO[Daypropval])
          : null}
        {this.state[prop].currentselection.indexOf("PlannerTask") >= 0 &&
          showplannertask
          ? this.GetPlanerTaskscom(
            this.state.PlannerTask[Daypropval]
          )
          : null}
        {this.state[prop].currentselection.indexOf("Events") >= 0 &&
          showevents
          ? this.GetOutlookEventscom(
            this.state.Events[Daypropval]
          )
          : null}

        {this.state[prop].currentselection.indexOf("TODOS") >= 0 &&
          showtodo
          ? this.GetOutlookTaskscom(this.state.TODOS[Daypropval])
          : null}

        {this.state[prop].currentselection.indexOf("FlaggedEmail") >= 0 &&
          showflagedemail
          ? this.GetFlaggedEmails(
            this.state.FlaggedEmail[Daypropval]
          )
          : null}

        {this.state[prop].currentselection.indexOf("MSList") >= 0 &&
          showMSListItem
          ? this.GetMSListWebpart(
            this.MSListAccumulated[Daypropval]
          )
          : null}           </div>
    );
  }
  public RenderFilesDashboard = () => {
    let colprops = ["RecentCol", "SharedCol", "AttachmentCol"];

    return (
      <div className="ms-Grid-row">
        {colprops.map((prop, keyindex) => {
          return (
            <div
              key={"Colview_" + keyindex}
              className="ms-Grid-col ms-sm12 ms-lg4"
            >
              <ColHeading
                data={this.state[prop]}
                changeview={this.FilterColData}
                language={this.culture}
                options={this.state[prop].currentselection}
                overAllView={this.overAllView}
              />
              {prop == 'RecentCol' && this.state.MyRecentFiles.length > 0

                ? this.GetFilesUI(this.state.MyRecentFiles, true, this.GetMyRecentFiles, this.NextURL.myrecent.currentpos, this.NextURL.myrecent.nextlist.length)
                : null}
              {prop == 'SharedCol' && this.state.SharedItems.length > 0
                ? this.GetFilesUI(this.state.SharedItems, false, this.GetSharedItems, this.NextURL.myshared.currentpos, this.NextURL.myshared.nextlist.length)
                : null}
              {prop == 'AttachmentCol' && this.state.AttachmentItems.length > 0
                ? this.GetFilesUI(this.state.AttachmentItems, false, this.GetAttachmentsItems, this.NextURL.myattachmnets.currentpos, this.NextURL.myattachmnets.nextlist.length)
                : null}
            </div>
          );
        })}

      </div>
    );
  }
  public componentDidMount() { 
    this.quickSearch();
    this.InitiateLoginin();
    
  }

  public InitiateLoginin=()=>{    
    try {     

      //if (window.location.port != "3000" && window.location.port != "3001") 
        // eslint-disable-next-line no-lone-blocks
        {        
          //window["m_IGServiceUrl"] = 'https://localhost:4431/';
          //m_IGServiceUrl = 'https://crmiglobe-stage.azurewebsites.net/';
          //m_IGServiceUrl = 'https://service.iglobecrm.com/';
          window["m_IGServiceUrl"] = 'https://igcrmteamapp.iglobe.dk/';
          window["m_CRMResourceURL"] = window["m_IGServiceUrl"] + "CRM/V3.0.0.3";
          
          if (typeof window.ssoTeamsToken === 'function') {
           
            
            app.getContext().then((context: app.Context) => {
                microsoftTeams.authentication.getAuthToken().then((result) => {
                  window.SSOTeamsForMIPA(context, result, this.CheckTokenStatus, this.CheckTokenStatus);
              }).catch((error) => {
                  
              });
            });



            //window.ssoTeamsToken(this.CheckTokenStatus, this.CheckTokenStatus);
            
           
          } 
         
          /*
        microsoftTeams.getContext((context: microsoftTeams.Context) => {
          this.email = context.userPrincipalName ? context.userPrincipalName : context.loginHint;
          this.culture = context.locale;

          this.CheckApplication((data) => {
            this.CheckSSOAuthentication(this.CheckTokenStatus, this.CheckTokenStatus);
          });
        });*/
      }
      /* else {
        //this.APIServiceurl = "https://localhost:44031/mipa";
        this.APIServiceurl = "http://localhost:1111/mipa";
        this.APIServiceurl = "http://localhost:29748/mipa";
        this.APIServiceurl = "https://localhost:44339/mipa";
        // this.serviceurl = "https://localhost:4431/IGlobeService.svc/";
        this.serviceurl = "https://localhost:4431/IGlobeService.svc/";


        this.email = "kh@iglobe.dk";
        //this.email = "das@iglobe.dk";
        //this.email='aek@iglobedemo.com';
        //this.email = "aek@iglobe.dk";
        //this.email='BCO@was.qld.edu.au';
        //this.O2SURL='https://localhost:44308/Home/MailSave';
        //this.email="aek@iglobedemo.com"; 
        //this.email="henrik.vestergaard@hydraspecma.com";
        //this.email='jim@ownerbuiltdesign.com';
        //this.email='richard@qgroup.uk';
        // this.email = "abi@insightoffice.dk";
        // this.email = "jab@iglobedemo.com";

        // henrik.vestergaard@hydraspecma.com or henv@hydra.dk\
        this.CheckApplication(this.CheckTokenStatus);
        this.FromDate = new Date(2020, 10, 20);
        // this.CheckTokenStatus();
      }*/
    } catch (ex) {
      
      this.serviceurl = "https://localhost:4431/IGlobeService.svc/";
      this.email = "das@iglobe.dk";
      this.APIServiceurl = "https://localhost:44031/";
    }
  }
  public RefreshSSOToken = () => {
    var intervaltime = 1000 * 60 * 5;
    setTimeout(() => {
      this.CheckSSOAuthentication(this.RefreshSSOToken, () => { });
    }, intervaltime);
  }
  public CheckSSOAuthentication = (fnsuccess, fnerror) => {
    var authTokenRequest = {
      resources: ['https://graph.microsoft.com'],
      successCallback: (result) => {
        var requestobj = {
          accessToken: result
        };
        if (result != null && result != '') {
          this.IsSSOEnabled = true;
          this.AcquireTokenFromServer(requestobj, fnsuccess);
        } else {
          if (this.props.isUsers == false) {
            let prevstate = { ...this.state };
            prevstate.ComponetName = "AdminConsent";
            this.ChangeState(prevstate);
            return;
          }
          fnerror();
        }
      },
      failureCallback: (error) => {
        if (this.props.isUsers == false) {
          let prevstate = { ...this.state };
          prevstate.ComponetName = "AdminConsent";
          this.ChangeState(prevstate);
          return;
        }

        console.log("Failure: " + error);
        fnerror();
        //$('#dvbody').html("Failure: " + JSON.stringify(error));
      }
    };
    microsoftTeams.authentication.getAuthToken(authTokenRequest);
  }
  public AcquireTokenFromServer = (requestobj, fnsuccess) => {
    var emailSyncServiceUrl = this.APIServiceurl + "/GetTokens";
    $.ajax({
      url: emailSyncServiceUrl,
      type: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(requestobj),
      dataType: 'json',
      success: (data) => {
        if (data.IsSuccess) {
          //graphtokenobj = data.GraphTokenObj;
          this.Graphtoken = data.GraphTokenObj.accessToken;
          if (this.APIHeader == null) {
            this.APIHeader = {};
          }
          this.APIHeader['sptoken'] = data.SPTokenObj.accessToken;
          this.APIHeader['mysptoken'] = data.MysiteTokenObj.accessToken;
          this.APIHeader['graphtoken'] = data.GraphTokenObj.accessToken;
          this.APIHeader['exttoken'] = data.ExchangeTokenObj.accessToken;
          this.APIHeader['Content-Type'] = "application/json; charset=utf-8";
          
          if (fnsuccess) {
            fnsuccess();
          }
        }
        else {
          var errorobj = JSON.parse(data.Message);
          if (errorobj.error == "invalid_grant" || errorobj.suberror == "consent_required" || errorobj.error_description.indexOf('AADSTS65001') >= 0) {
            if (this.props.isUsers == false) {
              let prevstate = { ...this.state };
              prevstate.ComponetName = "AdminConsent";
              this.ChangeState(prevstate);
              return;
            }
            else {
              this.setState({ ClientId: "abcd" });
            }
          } else {

          }

        }
      },
      error: (err) => {

        console.log(err);
      }
    });
  }
  public CheckTokenStatus = (data) => {
   
    try{
      this.Graphtoken = data.GraphTokenObj.accessToken;
      if (this.APIHeader == null) {
        this.APIHeader = {};
      }
      this.APIHeader['sptoken'] = data.SPTokenObj.accessToken;
      this.APIHeader['mysptoken'] =data.SPTokenObj.accessToken;
      this.APIHeader['graphtoken'] = data.GraphTokenObj.accessToken;
      this.APIHeader['exttoken'] = data.SPTokenObj.accessToken;
      this.APIHeader['Content-Type'] = "application/json; charset=utf-8";
    }
    catch(ex){
        console.log(ex);
    }
    this.CalculateDate();
    //this.FromDate=new Date(2020,9,21);
    window.RefreshSSOToken();

    this.checktokenSuccess(data);
    /*
    if (this.IsSSOEnabled) {
      this.RefreshSSOToken();
    }
    this.RefreshToken(this.checktokenSuccess);
    */ 
  };
  public checktokenSuccess = data => {
    let IsNewUser = false;
    /*if (data != null) {
      IsNewUser = data.FirstTime;

    }
    if (data.ClientId) {
      this.ClientId = data.ClientId;
    }*/



    if (data.IsSuccess) {
      if (IsNewUser && data.OrganizationId == '') { }
      /*this.appurl = data.SiteURL;
      this.sptoken = data.SPToken;
      this.Graphtoken = data.Token;
      this.GraphHeader = {
        Authorization: "Bearer " + data.Token,
        "Content-Type": "application/json; charset=utf-8"
      };*/
      this.appurl = data.LastAccessCRM;
      this.email=window["currentUserEmail"];
      this.sptoken = this.APIHeader['sptoken'];
      this.Graphtoken = this.APIHeader['graphtoken'];
      this.GraphHeader = {
        Authorization: "Bearer " + this.APIHeader['graphtoken'],
        "Content-Type": "application/json; charset=utf-8"
      };
      

      if (this.username == '') {
        this.GetCurrentUserInfo((res) => {
          this.CurrentUser = res.data;
          this.username = res.data.displayName;
          this.PrepareLogtitle();
        });

      }

      let readmailsetting = async () => {
        try {
          this.usertimezone = await GraphRequest.GetMailboxSetting(this.GraphHeader);
          this.haveEmailSetting = true;
        }
        catch (ex) {
          this.usertimezone = 'UTC';
          /*
          let prevstate = { ...this.state };
          prevstate.ComponetName = "MicrosoftLicRequirement";
          this.ChangeState(prevstate);
          return;*/
        }


        this.CheckLicenseInfo(data, () => {
          
          if (this.props.isSetting == false) {
          
            if (this.appurl && this.appurl != "") {
              //this.PrepareLogtitle();
              this.GetMeetingReport();
              this.GetSSOInfo();
            }

            //this.GetMyRecentFiles();
            //this.GetSharedItems();
            //this.GetAttachmentsItems();
            if(!window.IsMobileOperatingSystem()){
              this.GetPlannerTaks();
              if(this.haveEmailSetting){
                this.GetMyEvents();
                this.GetMyOutlookTasks();
                this.GetMyFlaggedEmails();
              }else{
                this.ResetMyEvent();
                this.ResetMyTODO();
                this.ResetMyFalgedEmail();  
              }
              
            }            
          }
          this.ReadMySetting();
        });
      };

      readmailsetting();

    } else {
      //this.OpenAuthenticaiton();
    }
  };
  public OpenAuthenticaiton = () => {
    /*microsoftTeams.authentication.authenticate(
        {
          url:'',
          width:600,
          height:700,
          successCallback:function(result){
            console.log(result);
            let tokenresult=JSON.parse(result);
            getUserProfile(tokenresult.AccessToken);
          },
          failureCallback:function(reason){
  
          }
        }
      );*/

    /*
var authTokenRequest = {
successCallback: function(result) { console.log("Success: " + result); },
failureCallback: function(error) { console.log("Failure: " + error); },
};
microsoftTeams.authentication.getAuthToken(authTokenRequest);
    */
    let prevstate = { ...this.state };
    prevstate.ShowLogin = true;
    this.ChangeState(prevstate);
  };
  public GetCurrentUserInfo = (fncalback, includemanager = false) => {
    let endpoint = MIAPACons.GraphAPI.ME;
    /* if(includemanager){
      endpoint +='?$expand=manager';
    } */
    let meapi = MIAPACons.GraphAPI.GraphBaseURL + endpoint;
    GraphRequest.GET(meapi, this.GraphHeader, res => {
      fncalback(res);
      //this.username =  res.data.displayName;
      //this.PrepareLogtitle();
    }, error => {
      console.error(error);
    }, p => { });
  }
  public RefreshToken = fnsuncess => {
    let fnSuccess = data => {
      if (window.location.port != "3000") {
        this.APIHeader = {
          'SourceURL': window.location.href,
          'usersessionid': data.request.getResponseHeader("usersessionid"),
          'userapp': 'mipa',
          'useremail': this.email,
          'Requast-ID': Helper.GetSecurityId(),
          'sptoken': data.request.getResponseHeader("sptoken"),
          'mysptoken': data.request.getResponseHeader("mysptoken"),
          'graphtoken': data.request.getResponseHeader("graphtoken"),
          'exttoken': data.request.getResponseHeader("exttoken"),
        };

      }
      if (data.data.IsAdmin > 0) {
        let organizationId = data.data.OrganizationId;
        this.CurrentUserOrganizationId = organizationId;
        let appid = "mipa";
        let allowedLicense = data.data.TotalLicense;
        let lickey = data.request.getResponseHeader("licid");
        let LicenseURL = "https://licenseadmin.iglobe.dk";
        let url = LicenseURL + "/Account/ManageUsers?orgId={0}&orgEmail={1}&app={2}&maxuser={3}&key={4}";

        this.adminurl = Helper.formatString([url, organizationId, this.email, appid, allowedLicense, lickey]);

      }

      fnsuncess(data.data);
    };
    let fnerror = error => {
      this.OpenAuthenticaiton();
    };
    var api =
      "/GetMIPAUser?email=" +
      this.email +
      "&UserName=" +
      this.username +
      "&source=1";
    this.SRequest.Post(
      this.APIServiceurl,
      api,
      null,
      fnSuccess,
      fnerror,
      this.ShowHideProgress,
      this.APIHeader
    );
  }
  public CheckApplication = fnsuncess => {
    let fnSuccess = (data, status, response) => {
      if (window.location.port != "3000") {
        this.APIHeader = {
          'SourceURL': window.location.href,
          'usersessionid': data.request.getResponseHeader("usersessionid"),
          'userapp': 'mipa',
          'useremail': this.email,
          'Requast-ID': Helper.GetSecurityId()
        };
      }
      if (data.data.ClientId) {
        this.ClientId = data.data.ClientId;
      }

      //this.APIHeader
      fnsuncess(data.data);
    };
    let fnerror = error => {
      this.OpenAuthenticaiton();
    };
    var api =
      "/Checkappliation?email=" +
      this.email +
      "&app=mipa";
    this.SRequest.Post(
      this.APIServiceurl,
      api,
      null,
      fnSuccess,
      fnerror,
      this.ShowHideProgress,
      { 'Requast-ID': Helper.GetSecurityId() }
    );
  }
  public CheckLicenseInfo = (data, successCallback) => {
    return successCallback();
    /*
  var org = null, shouldReturn = false;
  organizationId = data.OrganizationId;
  allowedLicense = data.TotalLicense;
  */
    if (data.OrganizationId == "") {
      let fnsuccess = orgDate => {
        orgDate = orgDate.data.value[0];
        var org = {
          OrganizationId: orgDate.id,
          Name: orgDate.displayName,
          ContactPerson: this.email,
          ContactEmail: this.email,
          Phone:
            orgDate.businessPhones == null ? "" : orgDate.businessPhones.join(),
          Address: orgDate.street,
          City: orgDate.city,
          Zip: orgDate.postalCode,
          State: orgDate.state,
          country: orgDate.country
        };

        let addorgsuccess = AddOrgdata => {
          AddOrgdata = AddOrgdata.data;
          if (AddOrgdata.IsCreated) {
            this.ReloadPage();
            this.ShowPlannerError("Reload app");
          } else {
            if (AddOrgdata.orgexist != null && AddOrgdata.orgexist) {
              if (AddOrgdata.IsExpired) {
                let prevstate = { ...this.state };
                prevstate.ComponetName = "LicExp";
                this.ChangeState(prevstate);
              } else {
                let prevstate = { ...this.state };
                prevstate.ComponetName = "LicLimitExced";
                prevstate.AdminEmail = AddOrgdata.Message[1];
                this.ChangeState(prevstate);
              }
              /*let message = Language.GetLanguageValue(
                this.culture,
                "orgexistmessage"
              );
              message = Helper.formatString([
                message,
                AddOrgdata.Message[0],
                AddOrgdata.Message[1]
              ]);
              this.ShowPlannerError(message);*/
            } else {
              this.ShowPlannerError(AddOrgdata.Message);
            }
            successCallback();
          }
        };
        let addorgfail = err => {
          this.ShowPlannerError("Fail to add organization try again");
        };
        // JSON.stringify(org)
        this.SRequest.Post(
          this.APIServiceurl,
          "/AddOrganization",
          org,
          addorgsuccess,
          addorgfail,
          this.ShowHideProgress
        );
      };
      let fnerror = error => {
        this.ShowPlannerError(
          "Fail to load organizatin inforamtion from your tenant."
        );
      };
      let orgapi =
        MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.Organization;
      GraphRequest.GET(
        orgapi,
        this.GraphHeader,
        fnsuccess,
        fnerror,
        this.ShowHideProgress
      );
    } else if (this.props.isUsers == false) {
      if (data.TotalLicense == 0) {
        let prevstate = { ...this.state };
        prevstate.ComponetName = "LicExp";
        this.ChangeState(prevstate);
        return;
      }
      if (data.IsAdmin < 0) {
        // New user but not added
        let message = "License limit reached!<br />";
        // tslint:disable-next-line: max-line-length
        message += Helper.formatString([
          "Ask administrtor {0} to get more subscription or add your email.",
          data.AdminEmails
        ]);
        this.ShowPlannerError(message);
        return;
      }
      if (data.TotalLicense < data.EmailAdded) {
        let prevstate = { ...this.state };
        prevstate.ComponetName = "LicLimitExced";
        prevstate.AdminEmail = data.AdminEmails;
        this.ChangeState(prevstate);


        return;
        /*let message =
          Language.GetLanguageValue(this.culture, "liclimitexceded") + " ";
        if (data.IsAdmin >= 1) {
          $("#btnloaduer").show();
          // tslint:disable-next-line: max-line-length
          message += Helper.formatString([
            Language.GetLanguageValue(this.culture, "liclimitadminmessage"),
            data.EmailAdded - data.TotalLicense
          ]);
        } else {
          // tslint:disable-next-line: max-line-length
          message += Helper.formatString([
            Language.GetLanguageValue(this.culture, "liclimitusermesasge"),
            data.EmailAdded - data.TotalLicense
          ]);
        }
        return this.ShowPlannerError(message);
        */
      }

      if (data.DaysRemain < 0) {
        let prevstate = { ...this.state };
        prevstate.ComponetName = "LicExp";
        this.ChangeState(prevstate);
      } else if (data.DaysRemain <= 10) {
        $('#splicense').html(Helper.formatString([Language.GetLanguageValue(this.culture, 'licdayremain'), data.DaysRemain]));
        successCallback();
      } else {
        successCallback();
      }
    } else {
      successCallback();
    }

    /*if (data.IsAdmin >= 1) {
      $('#loaduserbutton').show();
  }
  return shouldReturn;*/
  };
  public ReloadPage = () => {
    window.location.reload();
  };
  public ShowPlannerError = mesage => {
    let prevstate = { ...this.state };
    prevstate.ShowMessage = mesage;
    this.ChangeState(prevstate);
  };
  public GetMeetingReport = () => {

    let todate: any = DateHelper.GetDateStringInZeroHours(this.ToDate);
    todate.setDate(todate.getDate() + 1);

    let reqobj = {
      TargetOperation: "Meeting Report",
      SiteURL: this.appurl,
      UserName: this.email,
      AccessToken: this.sptoken,
      DateFrom: DateHelper.GetDateStringIn_yyyy_mm_dd_format(this.FromDate),
      DateTo: DateHelper.GetDateStringIn_yyyy_mm_dd_format(todate),
      FistDateOfNextWeek: DateHelper.GetDateStringIn_yyyy_mm_dd_format(this.ThisWeekEndDate)
    };

    let fnSuccess = response => {

      if (response.data.IsSucess && response.data.ReturnJsonString != "") {

        let listdata = JSON.parse(response.data.ReturnJsonString);
        if (response.data.OtherJsonString && response.data.OtherJsonString != "") {
          this.MeetingContacts = JSON.parse(response.data.OtherJsonString);
        }

        let meeting = Helper.GetColumnWiseData(listdata, "MeetingColmn");
        let prevstate = { ...this.state };

        prevstate.Meetings = meeting;
        prevstate.ToDayCol.Meetings = meeting.Today.length;
        prevstate.ThisWeekCol.Meetings = meeting.ThisWeek.length;
        prevstate.NextWeekCol.Meetings = meeting.NextWeek.length;
        prevstate.TodayTotal.TotalMeeting = meeting.Today.length;
        prevstate.LateTotal.TotalMeeting = meeting.Late.length;

        prevstate.ThisWeekTotal.TotalMeeting = meeting.Today.length + meeting.ThisWeek.length;
        prevstate.NextWeekTotal.TotalMeeting = meeting.NextWeek.length;
        this.ChangeState(prevstate);

      }
      else {
        this.ResetMeetingValues();
      }
    };

    let fnerror = (err: any) => {
      this.ResetMeetingValues();
    };

    this
      .SRequest
      .Post(this.serviceurl,
        "GetSPFXDashBoardData",
        reqobj,
        fnSuccess,
        fnerror,
        this.ShowHideProgress,this.APIHeader);
  }
  public ResetMeetingValues = () => {

    let prevstate = { ...this.state };
    prevstate.Meetings = {
      Today: [],
      ThisWeek: [],
      NextWeek: [],
      Late: new Array()
    };

    prevstate.ToDayCol.Meetings = 0;
    prevstate.ThisWeekCol.Meetings = 0;
    prevstate.NextWeekCol.Meetings = 0;
    prevstate.TodayTotal.TotalMeeting = 0;
    prevstate.LateTotal.TotalMeeting = 0;
    prevstate.NextWeekTotal.TotalMeeting = 0;
    this.ChangeState(prevstate);
  }
  public GetSSOInfo = () => {

    let todate: any = DateHelper.GetDateStringInZeroHours(this.ToDate);
    todate.setDate(todate.getDate() + 1);

    let reqobj = {
      TargetOperation: "Pipeline",
      SiteURL: this.appurl,
      UserName: this.email,
      AccessToken: this.sptoken,
      DateFrom: DateHelper.GetDateStringIn_yyyy_mm_dd_format(this.FromDate),
      DateTo: DateHelper.GetDateStringIn_yyyy_mm_dd_format(todate),
      FistDateOfNextWeek: DateHelper.GetDateStringIn_yyyy_mm_dd_format(this.ThisWeekEndDate)
    };

    let fnSuccess = response => {

      if (response.data.IsSucess && response.data.ReturnJsonString != "") {

        let listdata = JSON.parse(response.data.ReturnJsonString);
        if (response.data.OtherJsonString && response.data.OtherJsonString != "") {
          this.SSOContacts = JSON.parse(response.data.OtherJsonString);
        }

        let ssolist = Helper.GetColumnWiseData(listdata.List, "SSOColmn");
        ssolist.Probability = listdata.Probabilty;
        ssolist.Phases = listdata.Phases;
        ssolist.LogTitle = this.logtitle;

        let prevstate = { ...this.state };
        prevstate.SSO = ssolist;
        prevstate.ToDayCol.SSO = ssolist.Today.length;
        prevstate.ThisWeekCol.SSO = ssolist.ThisWeek.length;
        prevstate.NextWeekCol.SSO = ssolist.NextWeek.length;
        prevstate.TodayTotal.TotalSSO = ssolist.Today.length;
        prevstate.LateTotal.TotalSSO = ssolist.Late.length;

        prevstate.ThisWeekTotal.TotalSSO =
          ssolist.Today.length + ssolist.ThisWeek.length;

        prevstate.NextWeekTotal.TotalSSO = ssolist.NextWeek.length;

        this.ChangeState(prevstate);
      }
      else {
        this.ResetSSOViews();
      }
    };

    let fnerror = (err: any): void => {
      this.ResetSSOViews();
    };

    this
      .SRequest
      .Post(
        this.serviceurl,
        "GetSPFXDashBoardData",
        reqobj,
        fnSuccess,
        fnerror,
        this.ShowHideProgress,
        this.APIHeader
      );
  }
  public ResetSSOViews = () => {

    let prevstate = { ...this.state };

    prevstate.SSO = {
      Today: new Array(),
      ThisWeek: new Array(),
      NextWeek: new Array(),
      Probability: new Array(),
      Phases: new Array(),
      LogTitle: '',
      Late: new Array()
    };

    prevstate.ToDayCol.SSO = 0;
    prevstate.ThisWeekCol.SSO = 0;
    prevstate.NextWeekCol.SSO = 0;
    prevstate.TodayTotal.TotalSSO = 0;
    prevstate.LateTotal.TotalSSO = 0;

    prevstate.ThisWeekTotal.TotalSSO = 0;
    this.ChangeState(prevstate);
  }
  public GetPlannerTaks = (col = null, planid = '', fncallback = null, newTaskCreated: boolean = null) => {

    /* if(col==95){
      return this.InitiateLoginin();
    } */
    let prevstate = { ...this.state };
    if (col != null) {
      prevstate.PlannerTask.Today = new Array();
      prevstate.PlannerTask.ThisWeek = new Array();
      prevstate.PlannerTask.NextWeek = new Array();
      prevstate.PlannerTask.Late = new Array();
      prevstate.PlannerTask.WithoutdueDate = new Array();
      //this.ChangeState(prevstate);
      return this.InitiateLoginin();
    }

    var api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.Plans;

    if (this.state.GraphUsers == null || this.state.GraphUsers.length == 0) {

      let loadusers = async () => {

        let usreapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.Users;
        let users = await GraphRequest.GetItemsByGraph(usreapi,
          [],
          this.GraphHeader,
          this.ShowHideProgress);

        let prevstate = { ...this.state };
        prevstate.GraphUsers = users;
        this.ChangeState(prevstate);
      };

      loadusers();
    }

    let fnerror = error => {
      console.log(error);
    };


    let fnloadTasks = () => {

      let planBucketList = new Array();
      let selectedplan = this.currentplan;
      if (planid != '') {
        selectedplan = planid;
      }

      const apiBase = MIAPACons.GraphAPI.GraphBaseURL;
      const apiPath = planid == '' ? MIAPACons.GraphAPI.MyTasks : MIAPACons.GraphAPI.PlanTaks.replace("{0}", selectedplan);

      api = `${apiBase}${apiPath}?v=${Math.round(+new Date() / 1000)}`;
      let from = moment(moment(this.FromDate).format('YYYY-MM-DD')).toDate();

      let To = DateHelper.SetTimeToDate(this.ToDate, 23, 59, 0);

      GraphRequest.GetMyTasks(api, [], this.GraphHeader, from, To, this.ShowHideProgress)
        .then(AllTasks => {
          let PlannerTask = {
            Today: new Array(),
            ThisWeek: new Array(),
            NextWeek: new Array(),
            WithoutdueDate: new Array(),
            Late: new Array()
          };
          if (AllTasks && AllTasks.length > 0) {

            let NextWeekStart = this.ThisWeekEndDate;
            NextWeekStart = DateHelper.SetTimeToDate(NextWeekStart, 0, 0, 0);

            from = DateHelper.SetTimeToDate(from, 0, 0, 0);

            const LoopTasks = async () => {
              let totalPlannerTask = 0;
              let totalPlannerTaskThisWeek = 0;
              let totalPlannerTaskNextWeek = 0;
              let failplan = [];
              for (let index = 0; index < AllTasks.length; index++) {
                let item = AllTasks[index];
                let plan = this.myPlanList.filter(p => p.id == item.planId);
                if (plan && plan.length > 0) {
                  item.planeName = plan[0].title;
                  item.groupId = plan[0].owner;
                }
                else if (failplan.indexOf(item.planId) >= 0) {
                  if (fncallback == null) {
                    this.SetPlannerTaskState(index, AllTasks.length, PlannerTask, totalPlannerTask, totalPlannerTaskThisWeek, totalPlannerTaskNextWeek);
                  }
                  continue;
                }
                else {
                  try {
                    let planapi =
                      MIAPACons.GraphAPI.GraphBaseURL +
                      MIAPACons.GraphAPI.Plan.replace("{0}", item.planId);
                    let newplan = await GraphRequest.GetPlanById(
                      planapi,
                      this.GraphHeader
                    );
                    if (newplan) {
                      this.myPlanList.push(newplan);
                      item.planeName = newplan.title;
                      item.groupId = newplan.owner;
                    } else {
                      failplan.push(item.planId);
                      if (fncallback == null) {
                        this.SetPlannerTaskState(index, AllTasks.length, PlannerTask, totalPlannerTask, totalPlannerTaskThisWeek, totalPlannerTaskNextWeek);
                      }
                      continue;
                    }
                  } catch (Ex) {
                    failplan.push(item.planId);
                    if (fncallback == null) {
                      this.SetPlannerTaskState(index, AllTasks.length, PlannerTask, totalPlannerTask, totalPlannerTaskThisWeek, totalPlannerTaskNextWeek);
                    }
                    continue;
                  }
                }

                let bucket = planBucketList.filter(b => b.id == item.bucketId);
                if (bucket.length == 0) {
                  let bucketapi =
                    MIAPACons.GraphAPI.GraphBaseURL +
                    MIAPACons.GraphAPI.PlanBuckets.replace("{0}", item.planId);
                  planBucketList = planBucketList.concat(
                    await GraphRequest.GetPlannerBuckets(
                      bucketapi,
                      this.GraphHeader,
                      this.ShowHideProgress
                    )
                  );
                  bucket = planBucketList.filter(b => b.id == item.bucketId);
                  item.bucketName =
                    bucket && bucket.length > 0 ? bucket[0].name : "";
                } else {
                  item.bucketName = bucket[0].name;
                }
                item.buckets = planBucketList.filter(
                  b => b.planId == item.planId
                );
                if (item.dueDateTime == null) {
                  item.col = 1;
                  PlannerTask.WithoutdueDate.push(item);
                  continue;
                }
                let dueDate = new Date(item.dueDateTime);
                dueDate = DateHelper.SetTimeToDate(dueDate, 0, 0, 0);


                let dif = DateHelper.GetDateDiffInDays(dueDate, from);

                if (dueDate <= from) {
                  totalPlannerTask++;
                  item.col = 0;

                  if (dif >= 1) {
                    item.col = -1;
                    PlannerTask.Late.push(item);
                  } else {
                    PlannerTask.Today.push(item);
                  }

                }
                let thisweestartdate = DateHelper.SetTimeToDate(this.ThisWeekStartDate, 0, 0, 0);
                let nextweekenddate = DateHelper.SetTimeToDate(this.NextWeekEndDate, 23, 59, 0);
                if (dueDate >= thisweestartdate && dueDate < NextWeekStart) {
                  totalPlannerTaskThisWeek++;

                  if (dueDate < from) {
                    item.col = -1;
                  } else {
                    item.col = 1;
                  }
                  PlannerTask.ThisWeek.push(item);
                } else if (dueDate >= NextWeekStart && dueDate <= nextweekenddate) {
                  totalPlannerTaskNextWeek++;
                  item.col = 2;
                  PlannerTask.NextWeek.push(item);
                }
                else if (dueDate < thisweestartdate) {
                  item.col = -1;
                  //PlannerTask.Overdue.push(item);
                }
                if (fncallback == null) {
                  this.SetPlannerTaskState(index, AllTasks.length, PlannerTask, totalPlannerTask, totalPlannerTaskThisWeek, totalPlannerTaskNextWeek);
                } else {
                  //
                }
              }

              if (fncallback != null) {
                fncallback(PlannerTask);
              }
              else {
                this.SetPlannerTaskState(AllTasks.length, AllTasks.length, PlannerTask, totalPlannerTask, totalPlannerTaskThisWeek, totalPlannerTaskNextWeek);
              }
            };

            LoopTasks();
          } else {
            if (fncallback != null) {
              fncallback(PlannerTask);
            } else {

              this.SetPlannerTaskState(-1, 0, PlannerTask, 0, 0, 0);
            }
            //this.ResetPlannerView();
          }
        })
        .catch(error => {
          console.log("fail to load task");
          this.ResetPlannerView();
        });
    };

    let fnPlansuccess = responsedata => {
      this.myPlanList = [];
      var planMap = {};
      
      responsedata.data.responses.forEach((response) => {

        if (response.status === 200 &&
            response.body &&
            response.body.value) {

            response.body.value.forEach((plan)=> {
                const url = plan.container?.url;
                const isGroupOrUserUrl =  plan.container?.type === "group" || url?.includes("/users/");
                if (!planMap[plan.id] && isGroupOrUserUrl) {
                    planMap[plan.id] = true;
                    this.myPlanList.push(plan);
                }
            });
        }
    });
     this.myPlanList.sort(function (a, b) {
     return a.title.localeCompare(b.title);
 });
/*
      if (responsedata.data.value != null && responsedata.data.value.length > 0) {
        this.myPlanList = responsedata.data.value;
      }*/
      fnloadTasks();
    };

    if (this.myPlanList == null || this.myPlanList.length == 0) {
       var batchRequest = {
                    requests: [
                        {
                            id: "1",
                            method: "GET",
                            url: "/me/planner/recentPlans"
                        },
                        {
                            id: "2",
                            method: "GET",
                            url: "/me/planner/favoritePlans"
                        },
                        {
                            id: "3",
                            method: "GET",
                            url: "/me/planner/plans"
                        }
                    ]
                };
        GraphRequest.GET_BATCH_Beta(
        batchRequest,
        this.GraphHeader,
        fnPlansuccess,
        fnerror,
        this.ShowHideProgress
      );
                /*GraphRequest.GET(
        api,
        this.GraphHeader,
        fnPlansuccess,
        fnerror,
        this.ShowHideProgress
      );*/
    } else {
      fnloadTasks();
    }

  }
  private ResetPlannerView = () => {
    let prevstate = { ...this.state };
    prevstate.PlannerTask = {
      Today: new Array(),
      ThisWeek: new Array(),
      NextWeek: new Array(),
      //Overdue:new Array(),
      WithoutdueDate: new Array(),
      Late: new Array()
    };
    prevstate.ToDayCol.PlannerTask = -1;
    prevstate.ThisWeekCol.PlannerTask = -1;
    prevstate.NextWeekCol.PlannerTask = -1;
    prevstate.TodayTotal.TotalPlannerTask = -1;
    prevstate.LateTotal.TotalPlannerTask = -1;
    prevstate.ThisWeekTotal.TotalPlannerTask = -1;
    prevstate.NextWeekTotal.TotalPlannerTask = -1;

    this.ChangeState(prevstate);
  }
  private SetPlannerTaskState = (index, taskcount, PlannerTask, totalPlannerTask, totalPlannerTaskThisWeek, totalPlannerTaskNextWeek) => {
    if (index == taskcount - 1) {
      let prevstate = { ...this.state };
      prevstate.PlannerTask = { ...PlannerTask };
      prevstate.ToDayCol.PlannerTask = PlannerTask.Today.length;
      prevstate.ThisWeekCol.PlannerTask = PlannerTask.ThisWeek.length;
      prevstate.NextWeekCol.PlannerTask = PlannerTask.NextWeek.length;
      prevstate.TodayTotal.TotalPlannerTask = PlannerTask.Today.length;
      prevstate.LateTotal.TotalPlannerTask = PlannerTask.Late.length;
      prevstate.ThisWeekTotal.TotalPlannerTask = totalPlannerTaskThisWeek;
      prevstate.NextWeekTotal.TotalPlannerTask = totalPlannerTaskNextWeek;
      this.ChangeState(prevstate);
    }
  }
  private GetMyEvents = () => {

    let from = moment(this.ThisWeekStartDate).format('YYYY-MM-DD');
    let To = moment(this.ToDate).format('YYYY-MM-DD');
    let header = { ...this.GraphHeader };
    header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';

    let query = "$expand=singleValueExtendedProperties($filter%3Did eq '" + this.extpropid + "')&startDateTime=" + from + "&endDateTime=" + To + "";
    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyCalenderView + "?" + query;

    GraphRequest
      .GetItemsByGraph(api, [], header, this.ShowHideProgress)
      .then((AllEvents: any[]) => {

        if (AllEvents && AllEvents.length > 0) {

          let NextWeekStart = DateHelper.SetTimeToDate(this.ThisWeekEndDate, 0, 0, 0);
          let currentdatefrom = DateHelper.SetTimeToDate(this.FromDate, 0, 0, 0);
          let currentdateto = DateHelper.SetTimeToDate(this.FromDate, 23, 59, 0);
          let Eventlist = { Today: [], ThisWeek: [], NextWeek: [], Late: [] };

          Helper.SortList(AllEvents, 'start.dateTime', true, true);

          AllEvents.forEach(async (item, index) => {
            let singleValueExtendedProperties = item.singleValueExtendedProperties;
            item.booktime = 0;
            item.prepid = '';
            if (singleValueExtendedProperties && singleValueExtendedProperties.length > 0 && singleValueExtendedProperties[0].value) {
              if (singleValueExtendedProperties[0].value.indexOf('0####parentid') >= 0) {
                return;
              }
              let extdval = singleValueExtendedProperties[0].value.split('####');
              item.booktime = parseInt(extdval[0], 0);
              item.prepid = extdval[2];
            }
            let dueDate = new Date(item.start.dateTime);
            if (dueDate >= currentdatefrom && dueDate <= currentdateto) {
              item.col = 0;
              if (dueDate < this.FromDate) {
                item.col = -1;
              }
              Eventlist.Today.push(item);
            }
            if (dueDate < NextWeekStart) {
              item.col = 1;
              if (dueDate < this.FromDate) {
                item.col = -1;
              }
              Eventlist.ThisWeek.push(item);
            } else {
              item.col = 2;
              Eventlist.NextWeek.push(item);
            }

            if (index == AllEvents.length - 1) {

              let prevstate = { ...this.state };
              prevstate.Events = Eventlist;
              prevstate.ToDayCol.Events = Eventlist.Today.length;
              prevstate.ThisWeekCol.Events = Eventlist.ThisWeek.length;
              prevstate.NextWeekCol.Events = Eventlist.NextWeek.length;
              prevstate.TodayTotal.TotalEvents = Eventlist.Today.length;
              prevstate.LateTotal.TotalEvents = Eventlist.Late.length;
              prevstate.ThisWeekTotal.TotalEvents = Eventlist.ThisWeek.length;
              prevstate.NextWeekTotal.TotalEvents = Eventlist.NextWeek.length;

              this.ChangeState(prevstate);
            }
          });
        } else {
          this.ResetMyEvent();
        }

      })
      .catch(error => {
        console.log("No events found");
        this.ResetMyEvent();
      });
  }
  private ResetMyEvent = () => {
    let prevstate = { ...this.state };
    prevstate.Events = {
      Today: new Array(),
      ThisWeek: new Array(),
      NextWeek: new Array(),
      Late: new Array()
    };
    prevstate.ToDayCol.Events = 0;
    prevstate.ThisWeekCol.Events = 0;
    prevstate.NextWeekCol.Events = 0;
    prevstate.TodayTotal.TotalEvents = 0;
    prevstate.LateTotal.TotalEvents = 0;
    prevstate.ThisWeekTotal.TotalEvents = 0;
    prevstate.NextWeekTotal.TotalEvents = 0;
    this.ChangeState(prevstate);
  }
  private UpdateEvent = (eventid, event, col) => {
    if (col != null) {
      this.ChangeEventStatus(col, false);
    }
    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyEvents + '/' + eventid;
    let header = { ...this.GraphHeader };
    header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';
    GraphRequest.Patch(api,
      header,
      event,
      (sucessfullresponse) => {
        this.GetMyEvents();
      },
      (errorresponse) => {
        console.log('Fail to update event', errorresponse);
        this.GetMyEvents();
      },
      this.ShowHideProgress)
  }
  private CreateOrCancelPreperationEvent = (parentevtid, childevtid, evt, col, min) => {

    var patchobj = {
      "singleValueExtendedProperties": [
        {
          "id": this.extpropid,
          "value": null
        }
      ]
    };


    this.ChangeEventStatus(col, false);
    let fnsuccess = response => {
      if (response.data) {
        patchobj.singleValueExtendedProperties[0].value = min + "####childid####" + response.data.id;
      }
      this.UpdateEvent(parentevtid, patchobj, null);
      // this.GetMyEvents();
    };
    let fnError = error => {
      console.log("Fail to update event");
      this.UpdateEvent(parentevtid, patchobj, null);
    };
    let header = { ...this.GraphHeader };
    //header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';

    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyEvents;
    if (childevtid != '' && childevtid != null) {
      GraphRequest.Delete(
        api + '/' + childevtid,
        header,
        fnsuccess,
        fnError,
        this.ShowHideProgress
      );
    }
    else {
      GraphRequest.POST(
        api,
        header,
        evt,
        fnsuccess,
        fnError,
        this.ShowHideProgress
      );
    }
  }
  private AcceptEvent = (endpoint, col) => {
    this.ChangeEventStatus(col, false);
    let fnsuccess = response => {
      this.GetMyEvents();
    };
    let fnError = error => {
      console.log("Fail to update event");
    };
    let header = { ...this.GraphHeader };
    //header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';

    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyEvents + endpoint;

    GraphRequest.POST(
      api,
      header,
      null,
      fnsuccess,
      fnError,
      this.ShowHideProgress
    );
  }
  private GetCRMContactCompany = (crmcontactemail, fnSuccess) => {
    if (this.appurl == null || this.appurl == '') {
      return fnSuccess(null);
    }
    let reqobj = {
      SiteURL: this.appurl,
      UserName: crmcontactemail,
      AccessToken: this.sptoken,
      TokenFromDB: false
    };

    let fnerror = err => {
      console.log("Error occured when read contact company", err);
    };
    this.SRequest.Post(
      this.serviceurl,
      "GetSPFXContactCompany",
      reqobj,
      (response) => {
        let result = response.data;
        if (result.IsSucess && result.ReturnJsonString != '') {
          fnSuccess(response, this.serviceurl);
        } else {
          this.GetoutlookContactDetails(crmcontactemail, fnSuccess);
        }

      },
      fnerror,
      this.ShowHideProgress,
      this.APIHeader
    );
  }
  private Getcrmdataforrecent = (crmcontactemail, contactid, companyid, fnSuccess) => {
    if (this.appurl == null || this.appurl == '') {
      return fnSuccess(null);
    }
    // let url=this.serviceurl+'GetSPFXDashBoardData';
    let reqobj = {
      SiteURL: this.appurl,
      UserName: crmcontactemail,
      AccessToken: this.sptoken,
      TokenFromDB: false
    };

    let fnerror = err => {
      console.log("Error occured when read meeting report", err);
    };
    this.SRequest.Post(
      this.serviceurl,
      `GetSPFXContactRecentData?contactId=${contactid}&companyId=${companyid}`,
      reqobj,
      (response) => {
        fnSuccess(response, this.serviceurl);
      },
      fnerror,
      this.ShowHideProgress,
      this.APIHeader
    );
  }
  private ChangeEventStatus = (col, loadalso) => {
    let prevstate = { ...this.state };
    if (col <= 0) {
      prevstate.Events.Today = new Array();
    } else if (col === 1) {
      prevstate.Events.ThisWeek = new Array();
    } else {
      prevstate.Events.NextWeek = new Array();
    }
    this.ChangeState(prevstate);
    if (loadalso) {
      this.GetMyEvents();
    }
  }
  private GetoutlookContactDetails = (email, fnsuccess) => {
    let fnError = error => {
      console.log("Fail to read contact details", error);
    };
    let header = { ...this.GraphHeader };

    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyContacts + `?$filter=emailAddresses/any(r:r/address eq '${email}')`;

    GraphRequest.GET(
      api,
      header,
      fnsuccess,
      fnError,
      this.ShowHideProgress
    );

  }
  private GetContactRelatedMails = (email, fnsuccess) => {
    //https://graph.microsoft.com/v1.0/me/messages?$search="from:aek@iglobe.dk OR to:samaresh.das@ixorasolution.com"&$top=10&$select=id,hasAttachments,subject,importance,conversationId,from,toRecipients,ccRecipients,webLink
    let fnError = error => {
      console.log("Fail to read contact emails", error);
    };
    let header = { ...this.GraphHeader };
    header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';
    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyFlagEmails + `?$search="from:${email} OR to:${email} OR cc:${email}"&$top=10&$select=id,hasAttachments,subject,bodyPreview,importance,conversationId,from,toRecipients,ccRecipients,webLink,receivedDateTime,sentDateTime`;

    GraphRequest.GET(
      api,
      header,
      fnsuccess,
      fnError,
      this.ShowHideProgress
    );
  }
  private GetOutlookemailAttachments = (endpoint, fnsuccess) => {

    let fnError = error => {
      console.log("Fail to read contact details", error);
    };
    let header = { ...this.GraphHeader };
    header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';
    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyEmailAttachments.replace('{0}', endpoint);
    if (endpoint.indexOf('v1.0') >= 0) {
      api = MIAPACons.GraphAPI.GraphBaseURL + endpoint;
    }

    GraphRequest.GET(
      api,
      header,
      fnsuccess,
      fnError,
      this.ShowHideProgress
    );
  }
  private GetMyOutlookTasks = () => {

    let header = { ...this.GraphHeader };
    header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';
    let filter = "$filter=status ne 'completed'";

    let api =
      MIAPACons.GraphAPI.GraphBaseURL +
      MIAPACons.GraphAPI.MyOutlookTasks +
      "?" +
      filter;

    GraphRequest.GetItemsByGraph(api, [], header, this.ShowHideProgress)
      .then(AllEvents => {
        if (AllEvents && AllEvents.length > 0) {

          let NextWeekStart = DateHelper.SetTimeToDate(this.ThisWeekEndDate, 0, 0, 0);
          let thisWeekStart = DateHelper.SetTimeToDate(this.ThisWeekStartDate, 0, 0, 0);

          let TODOList = { Today: [], ThisWeek: [], NextWeek: [], Late: [] };
          let totaltodosthisweek = 0;
          let totaltodosnextweek = 0;

          let currentdatefrom = moment(moment(this.FromDate).format('YYYY-MM-DD')).toDate();
          let currentdateto = moment(moment(this.FromDate).format('YYYY-MM-DD')).toDate();
          currentdateto.setHours(23);
          currentdateto.setMinutes(59);
          currentdateto.setSeconds(0);

          AllEvents.forEach(async (item, index) => {
            if (item.dueDateTime) {
              let dueDate = moment(item.dueDateTime.dateTime).toDate();
              if (dueDate <= this.ToDate) {
                if (dueDate < currentdateto) {
                  item.col = 0;
                  if (dueDate < currentdatefrom) {
                    item.col = -1;
                    TODOList.Late.push(item);
                  } else {
                    TODOList.Today.push(item);
                    totaltodosthisweek++;
                  }
                }
                if (dueDate < NextWeekStart && dueDate > thisWeekStart) {
                  item.col = 1;
                  TODOList.ThisWeek.push(item);
                  totaltodosthisweek++;
                } else if (dueDate >= NextWeekStart && dueDate <= this.NextWeekEndDate) {
                  item.col = 2;
                  TODOList.NextWeek.push(item);
                  totaltodosnextweek++;
                }
              }
            }
            if (index == AllEvents.length - 1) {
              let prevstate = { ...this.state };
              prevstate.TODOS = TODOList;
              prevstate.ToDayCol.TODOS = TODOList.Today.length;
              prevstate.ThisWeekCol.TODOS = TODOList.ThisWeek.length;
              prevstate.NextWeekCol.TODOS = TODOList.NextWeek.length;
              prevstate.TodayTotal.TotalTODOS = TODOList.Today.length;
              prevstate.LateTotal.TotalTODOS = TODOList.Late.length;
              prevstate.ThisWeekTotal.TotalTODOS = totaltodosthisweek;
              prevstate.NextWeekTotal.TotalTODOS = totaltodosnextweek;
              this.ChangeState(prevstate);
            }
          });
        } else {
          this.ResetMyTODO();
        }

      })
      .catch(error => {
        console.log("NO TODO found");
        this.ResetMyTODO();
      });
  }
  private ResetMyTODO = () => {
    let prevstate = { ...this.state };
    prevstate.TODOS = {
      Today: new Array(),
      ThisWeek: new Array(),
      NextWeek: new Array(),
      Late: new Array()
    };
    prevstate.ToDayCol.TODOS = 0;
    prevstate.ThisWeekCol.TODOS = 0;
    prevstate.NextWeekCol.TODOS = 0;
    prevstate.TodayTotal.TotalTODOS = 0;
    prevstate.LateTotal.TotalTODOS = 0;
    prevstate.ThisWeekTotal.TotalTODOS = 0;
    prevstate.NextWeekTotal.TotalTODOS = 0;
    this.ChangeState(prevstate);
  }
  private GetMyFlaggedEmails = () => {

    let To = moment(this.ToDate).format('YYYY-MM-DD');

    let header = { ...this.GraphHeader };
    header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';

    let filter = "$filter=flag/flagStatus eq 'flagged' and  flag/dueDateTime/dateTime le '" + To + "'";
    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyFlagEmails + "?$top=20&" + filter;

    let currentfrom = moment(moment(this.FromDate).format('YYYY-MM-DD')).toDate();
    let currentto = moment(moment(this.FromDate).format('YYYY-MM-DD')).toDate();
    currentto.setHours(23);
    currentto.setMinutes(59);
    currentto.setSeconds(0);

    GraphRequest
      .GetItemsByGraph(api, [], header, this.ShowHideProgress)
      .then(allitems => {
        if (allitems && allitems.length > 0) {

          let NextWeekStart = DateHelper.SetTimeToDate(this.ThisWeekEndDate, 0, 0, 0);

          let Flaggedemaillist = { Today: [], ThisWeek: [], NextWeek: [], Late: [] };
          let totaltodosthisweek = 0;
          let totaltodosnextweek = 0;

          allitems.forEach(async (item: OutlookEmailobj, index) => {

            if (item.flag.dueDateTime) {

              let dueDate = moment(item.flag.dueDateTime.dateTime).toDate();

              if (dueDate <= this.ToDate) {
                if (dueDate < currentto) {
                  item.col = 0;
                  if (dueDate < currentfrom) {
                    item.col = -1;
                    Flaggedemaillist.Late.push(item);
                  } else {
                    Flaggedemaillist.Today.push(item);
                    totaltodosthisweek++;
                  }
                }

                if (dueDate < NextWeekStart && dueDate >= this.ThisWeekStartDate) {
                  item.col = 1;
                  Flaggedemaillist.ThisWeek.push(item);
                  totaltodosthisweek++;
                } else if (dueDate >= NextWeekStart) {
                  item.col = 2;
                  Flaggedemaillist.NextWeek.push(item);
                  totaltodosnextweek++;
                }
              }
            }
            if (index == allitems.length - 1) {

              let prevstate = { ...this.state };
              prevstate.FlaggedEmail = Flaggedemaillist;
              prevstate.ToDayCol.FlaggedEmail = Flaggedemaillist.Today.length;
              prevstate.ThisWeekCol.FlaggedEmail = Flaggedemaillist.ThisWeek.length;
              prevstate.NextWeekCol.FlaggedEmail = Flaggedemaillist.NextWeek.length;
              prevstate.TodayTotal.TotalFlaggedEmail = Flaggedemaillist.Today.length;
              prevstate.LateTotal.TotalFlaggedEmail = Flaggedemaillist.Late.length;
              prevstate.ThisWeekTotal.TotalFlaggedEmail = totaltodosthisweek;
              prevstate.NextWeekTotal.TotalFlaggedEmail = totaltodosnextweek;
              this.ChangeState(prevstate);
            }
          });
        } else {
          this.ResetMyFalgedEmail();
        }
      })
      .catch(error => {
        console.log("NO Flagged email found");
        this.ResetMyFalgedEmail();
      });
  }
  private ResetMyFalgedEmail = () => {
    let prevstate = { ...this.state };
    prevstate.FlaggedEmail = {
      Today: new Array(),
      ThisWeek: new Array(),
      NextWeek: new Array(),
      Late: new Array()
    };
    prevstate.ToDayCol.FlaggedEmail = 0;
    prevstate.ThisWeekCol.FlaggedEmail = 0;
    prevstate.LateTotal.TotalFlaggedEmail = 0;
    prevstate.TodayTotal.TotalFlaggedEmail = 0;
    prevstate.ThisWeekTotal.TotalFlaggedEmail = 0;
    prevstate.NextWeekTotal.TotalFlaggedEmail = 0;
    this.ChangeState(prevstate);
  }
  private GetMyRecentFiles = (requestpos = 0) => {
    let api = this.NextURL.myrecent.nextlist[requestpos];
    /* if(api==''){
      api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyRecentFiles+'?$top=30';
    } */
    let prevstate = { ...this.state };
    if (prevstate.MyRecentFiles && prevstate.MyRecentFiles.length > 0) {
      prevstate.MyRecentFiles = [];
      this.ChangeState(prevstate);
    }

    GraphRequest.GET(api,
      this.GraphHeader,
      (result) => {

        let tlen = this.NextURL.myrecent.nextlist.length;
        if (requestpos == tlen - 1 && result.data['@odata.nextLink']) {
          this.NextURL.myrecent.nextlist.push(result.data['@odata.nextLink']);
        }
        this.NextURL.myrecent.currentpos = requestpos;
        let allitems = result.data.value.filter((e) => { return e.folder == null });
        prevstate = { ...this.state };
        prevstate.MyRecentFiles = allitems;
        let filecount = allitems.length;
        prevstate.ToDayCol.RecentFiels = filecount;
        prevstate.ThisWeekCol.RecentFiels = filecount;
        prevstate.NextWeekCol.RecentFiels = filecount;
        //prevstate.ColViewTotal.TotalRecentFiles = filecount;
        prevstate.TodayTotal.TotalRecentFiles = filecount;
        prevstate.ThisWeekTotal.TotalRecentFiles = filecount;
        prevstate.NextWeekTotal.TotalRecentFiles = filecount;
        this.ChangeState(prevstate);
      },
      (error) => {
        console.log("No recent files foound");
      },
      this.ShowHideProgress);

  }
  private GetSharedItems = (requestpos = 0) => {
    let api = this.NextURL.myshared.nextlist[requestpos];

    let prevstate = { ...this.state };
    if (prevstate.SharedItems && prevstate.SharedItems.length > 0) {
      prevstate.SharedItems = [];
      this.ChangeState(prevstate);
    }
    // let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.SharedWithMe+'?$top=30';
    GraphRequest.GET(api,
      this.GraphHeader,
      (result) => {
        if (this.NextURL.myshared.currentpos == this.NextURL.myshared.nextlist.length - 1 && result.data['@odata.nextLink']) {
          this.NextURL.myshared.nextlist.push(result.data['@odata.nextLink']);
        }
        this.NextURL.myshared.currentpos = requestpos;
        let allitems = result.data.value.filter((e) => { return e.folder == null });
        let prevstate = { ...this.state };
        prevstate.SharedItems = allitems;
        this.ChangeState(prevstate);

      },
      (error) => {
        console.log("No recent files foound");
      },
      this.ShowHideProgress);
  }
  private GetAttachmentsItems = (requestpos = 0) => {
    let api = this.NextURL.myattachmnets.nextlist[requestpos];

    let prevstate = { ...this.state };
    if (prevstate.AttachmentItems && prevstate.AttachmentItems.length > 0) {
      prevstate.AttachmentItems = [];
      this.ChangeState(prevstate);
    }
    // let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MyAttachments;
    GraphRequest.GET(api,
      this.GraphHeader,
      (result) => {
        if (this.NextURL.myattachmnets.currentpos == this.NextURL.myattachmnets.nextlist.length - 1 && result.data['@odata.nextLink']) {
          this.NextURL.myattachmnets.nextlist.push(result.data['@odata.nextLink']);
        }
        this.NextURL.myattachmnets.currentpos = requestpos;
        let allitems = result.data.value;
        // console.log('MyAttachments',allitems);
        prevstate = { ...this.state };
        prevstate.AttachmentItems = allitems;
        this.ChangeState(prevstate);
      },
      (error) => {
        console.log("No recent files foound");
      },
      this.ShowHideProgress);
  }
  private ReadMySetting = () => {
    let medatavalue = null;
    if (this.myManager == null) {
      this.GetCurrentUserInfo((res) => {
        medatavalue = res;
        this.CurrentUser = res.data;
        if (res.data.manager != null) {
          this.myManager = {
            UserID: res.data.manager.id,
            Name: res.data.manager.displayName,
            Email: res.data.manager.mail,
            jobTitle: res.data.manager.jobTitle,
            mobilePhone: res.data.manager.mobilePhone,
          };
        } else {
          medatavalue = {};
        }

      }, true);


      /* let sacretarapi =MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.DirectReporters;
    GraphRequest.GET(sacretarapi,this.GraphHeader,res=>{
      if(res.data.value!=null && res.data.value.length>0){
        res.data.value.forEach((val,index)=>{
          this.mySecretaryList.push(
            {
              UserID:val.id,
              Name:val.displayName,
              Email:val.mail,
              jobTitle:val.jobTitle,
              mobilePhone:val.mobilePhone,          
            }
          );
        });
      }
    },error=>{
      console.error(error);
    },p=>{}); */

    }
    let fnUpdateMeData = () => {
      if (this.MySettingInfo.Me == null || this.MySettingInfo.Me.UserID == '') {
        let fnMeReadSuccess = (res) => {
          let meobj = {
            UserID: res.data.id,
            Name: res.data.displayName,
            Email: this.email,
            SiteUrl: this.userSiteURL
          };
          this.MySettingInfo.Me = meobj;


          let reqobj = {
            SiteURL: this.userSiteURL,
            UserEmail: this.email
          };
          this.SRequest.Post(
            this.APIServiceurl,
            '/UpdateMeData',
            { config: reqobj, MeInfo: meobj },
            (successres) => {

            },
            (errorres) => {

              console.log(errorres);
            },
            this.ShowHideProgress,
            this.APIHeader
          );
        };
        if (medatavalue == null) {
          this.GetCurrentUserInfo(fnMeReadSuccess);
        } else {
          fnMeReadSuccess(medatavalue);
        }

      }
    };

    let header = { ...this.GraphHeader };
    let api = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.MySite;

    let ReadFromAPI = () => {
      this.ReadMIPAConfigFiles((successres) => {
        if (successres && successres.data && successres.data.IsSuccess) {
          this.ShowSettingButton = true;
          this.MySettingInfo = successres.data.data;
          this.setState({ changed: true });
          this.GetMSListData();
          fnUpdateMeData();
        }
      }, "MyConfig");
      /* var api ="/GetMyListConfiguration";
    let objRequest={
      //ListTitle:this.ListTitle,
      SiteURL:this.userSiteURL,
      UserEmail:this.email,
      ConfigType:"MyConfig"

    };
      this.SRequest.Post(
        this.APIServiceurl,
        api,
        objRequest,
        (successres)=>{
         if(successres && successres.data && successres.data.IsSuccess){
          this.ShowSettingButton=true;
          this.MySettingInfo=successres.data.data;
          this.setState({changed:true});
          this.GetMSListData();
          fnUpdateMeData();
         }
        },
        (errorres)=>{
    
          console.log(errorres);
        },
        this.ShowHideProgress,
        this.APIHeader
      ); */
    };

    if (this.userSiteURL != null && this.userSiteURL != '') {
      ReadFromAPI();
    } else {
      GraphRequest.GET(api,
        header,

        (sucessfullresponse) => {
          this.userSiteURL = sucessfullresponse.data.value;
          ReadFromAPI();
          //this.ShowSettingButton=true;
        },
        (errorresponse) => {
          console.log('Fail to read my site', errorresponse);

        },
        this.ShowHideProgress);
    }

  }
  public ReadMIPAConfigFiles = (fnsuccess, configname) => {
    var api = "/GetMyMIPAconfigData";
    let objRequest = {
      //ListTitle:this.ListTitle,
      SiteURL: this.userSiteURL,
      UserEmail: this.email,
      ConfigType: configname

    };
    this.SRequest.Post(
      this.APIServiceurl,
      api,
      objRequest,
      fnsuccess,
      (errorres) => {

        console.log(errorres);
      },
      this.ShowHideProgress,
      this.APIHeader
    );
  }
  public GetMSListData = () => {
    if (this.ShowSettingButton == true && this.MySettingInfo.ListInfo != null && this.MySettingInfo.ListInfo.length > 0) {
      let fnLoadMSListData = (query, listconfig) => {
        let fnSuccess = successres => {
          if (successres && successres.data && successres.data.IsSuccess) {
            let listdata = successres.data.data.Items;
            this.MSlistUsers[listconfig.ID] = successres.data.data.Users;
            listdata = Helper.GetColumnWiseData(listdata, "Col");
            this.MSListAccumulated.Today = this.MSListAccumulated.Today.concat(listdata.Today);
            this.MSListAccumulated.Late = this.MSListAccumulated.Late.concat(listdata.Late);
            this.MSListAccumulated.ThisWeek = this.MSListAccumulated.ThisWeek.concat(listdata.ThisWeek);
            this.MSListAccumulated.NextWeek = this.MSListAccumulated.NextWeek.concat(listdata.NextWeek);
            let prevstate = { ...this.state };
            prevstate.MSList = listdata;
            prevstate.ToDayCol.MSList = this.MSListAccumulated.Today.length;
            prevstate.ThisWeekCol.MSList = this.MSListAccumulated.ThisWeek.length;
            prevstate.NextWeekCol.MSList = this.MSListAccumulated.NextWeek.length;
            prevstate.TodayTotal.TotalMSList = this.MSListAccumulated.Today.length;
            prevstate.LateTotal.TotalMSList = this.MSListAccumulated.Late.length;
            prevstate.ThisWeekTotal.TotalMSList = this.MSListAccumulated.Today.length + this.MSListAccumulated.ThisWeek.length;
            prevstate.NextWeekTotal.TotalMSList = this.MSListAccumulated.NextWeek.length;
            this.ChangeState(prevstate);
          } else {
            //this.ResetSSOViews();
          }
        };
        let fnerror = err => {
          console.log("Error occured when read SSO", err);
          //this.ResetSSOViews();
        };
        var api = "/GetMicrosoftListData";
        this.SRequest.Post(
          this.APIServiceurl,
          api,
          { config: query, listinfo: listconfig },
          fnSuccess,
          fnerror,
          this.ShowHideProgress,
          this.APIHeader
        );
      };
      this.MSListAccumulated = {
        Today: new Array(),
        ThisWeek: new Array(),
        NextWeek: new Array(),
        Late: new Array()
      };
      this.MySettingInfo.ListInfo.map((list: MSListConfig) => {
        let queryobj = {
          SiteURL: list.SiteURL,
          ListTitle: list.ListTitle,
          UserEmail: this.email,
          DateFrom: DateHelper.GetDateStringIn_yyyy_mm_dd_format(this.FromDate),
          DateTo: DateHelper.GetDateStringIn_yyyy_mm_dd_format(this.ToDate),
          FistDateOfNextWeek: DateHelper.GetDateStringIn_yyyy_mm_dd_format(this.ThisWeekEndDate)
        };
        fnLoadMSListData(queryobj, list);
      });
    }
  }
  private GetUserImage = userid => {
    if (Mipa.Assigneeusers == null) {
      Mipa.Assigneeusers = new Array();
    }
    if (Mipa.Assigneeusers.indexOf(userid) >= 0) {
      return;
    }
    Mipa.Assigneeusers.push(userid);

    var request = new XMLHttpRequest();
    request.open(
      "GET",
      "https://graph.microsoft.com/v1.0/users/" + userid + "/photo/$value"
    );
    request.setRequestHeader("Authorization", "Bearer " + this.Graphtoken);
    request.responseType = "blob";
    //this.ShowHideProgress(1);
    request.onload = () => {
      if (request.readyState == 4 && request.status == 200) {
        let url = window.URL;
        let imageurl = url.createObjectURL(request.response);
        this.SetImageurl(userid, imageurl);
      }
      //this.ShowHideProgress(-1);
    };
    try {
      request.send(null);
    } catch (ex) {
      // this.SetImageurl(userid,imageurl);
      //this.ShowHideProgress(-1);
    }
  }
  private SetImageurl = (userid, imageurl) => {
    let prevstate = { ...this.state };
    let users = prevstate.GraphUsers;
    let user = users.filter(u => u.id == userid);
    if (userid && userid.length > 0) {
      user[0].imagepath = imageurl;
    }

    prevstate.GraphUsers = users;
    this.ChangeState(prevstate);
  }
  private CalculateDate = () => {

    const dayStartHour = 11;
    const dayStartMnt = 30;
    const dayStartSeconds = 0;

    this.ThisWeekStartDate = moment().startOf('week').hours(dayStartHour).minutes(dayStartMnt).seconds(dayStartSeconds).toDate();
    this.ThisWeekEndDate = moment().endOf('week').hours(dayStartHour).minutes(dayStartMnt).seconds(dayStartSeconds).toDate();

    this.NextWeekStartDate = moment().day(7).startOf('week').hours(dayStartHour).minutes(dayStartMnt).seconds(dayStartSeconds).toDate();
    this.NextWeekEndDate = moment().day(7).endOf('week').hours(dayStartHour).minutes(dayStartMnt).seconds(dayStartSeconds).toDate();

    this.FromDate = moment().toDate();
    this.ToDate = moment(this.NextWeekEndDate).hours(23).minutes(59).toDate();
  }
  private RefreshCRMData=(col, changeitemgroup)=>{
        //let changeitemprop = isSSO ? "SSO" : "Meetings";
        let prevstate = { ...this.state };
        
        if (col <= 0) {
          prevstate[changeitemgroup].Today = new Array();
        } else if (col == 1) {
          prevstate[changeitemgroup].ThisWeek = new Array();
        } else {
          prevstate[changeitemgroup].NextWeek = new Array();
        }
        this.ChangeState(prevstate);
        changeitemgroup=='SSO' ? this.GetSSOInfo() : this.GetMeetingReport();
  }
  private UpdateCRMData = (data, col, isSSO) => {
    let fnsuccess = response => {
      if (response.data.IsSucess) {
        let prevstate = { ...this.state };
        let changeitemprop = isSSO ? "SSO" : "Meetings";
        if (col <= 0) {
          prevstate[changeitemprop].Today = new Array();
        } else if (col == 1) {
          prevstate[changeitemprop].ThisWeek = new Array();
        } else {
          prevstate[changeitemprop].NextWeek = new Array();
        }
        this.ChangeState(prevstate);
        if (
          isSSO &&
          data.fieldslist.filter(x => x.spfieldname == "IGlobeCRM_SSO_Pipeline")
            .length > 0
        ) {
          this.SRequest.Post(
            this.serviceurl,
            "CreateSSOMovement?ssoid=" + data.ID,
            this.PrepareCRMUser(),
            movementresult => {
              console.log("SSO movement updated");
            },
            err => {
              console.log("Fail to update sso movement", err);
            },
            this.ShowHideProgress,
            this.APIHeader
          );
        }

        isSSO ? this.GetSSOInfo() : this.GetMeetingReport();
      }
    };
    let fnError = error => {
      console.log("Fail to update", error);
    };
    var wraper = {
      spentity: data,
      userinfo: this.PrepareCRMUser()
    };

    this.SRequest.Post(
      this.serviceurl,
      "UpdateListItem",
      wraper,
      fnsuccess,
      fnError,
      this.ShowHideProgress,
      this.APIHeader
    );
  }
  private UpdateToDoItem = (ID, task, col) => {
    let fnsuccess = response => {
      if (response.data) {
        let prevstate = { ...this.state };

        if (col <= 0) {
          prevstate.TODOS.Today = new Array();
        } else if (col == 1) {
          prevstate.TODOS.ThisWeek = new Array();
        } else {
          prevstate.TODOS.NextWeek = new Array();
        }
        this.ChangeState(prevstate);
        this.GetMyOutlookTasks();
      }
    };
    let fnError = error => {
      console.log("Fail to update todo");
    };
    let header = { ...this.GraphHeader };
    //header["Prefer"] = 'outlook.timezone="' + Helper.getTimeZoneId() + '"';
    header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';

    let api =
      MIAPACons.GraphAPI.GraphBaseURL +
      MIAPACons.GraphAPI.MyOutlookTasks +
      "/" +
      ID;

    GraphRequest.Patch(
      api,
      header,
      task,
      fnsuccess,
      fnError,
      this.ShowHideProgress
    );
  };
  private UpdatePlannerTask = (ID, task, etag, col, isbeta, fnCallback) => {

    let prevstate = { ...this.state };
    prevstate.PlannerTask.Today = new Array();
    prevstate.PlannerTask.ThisWeek = new Array();
    prevstate.PlannerTask.NextWeek = new Array();
    prevstate.PlannerTask.Late = new Array();
    prevstate.PlannerTask.WithoutdueDate = new Array();

    this.ChangeState(prevstate);
    let fnsuccess = response => {
      if (response.data) {
        if (fnCallback) {
          return fnCallback()
        }
        else {
          this.GetPlannerTaks();
        }
      }
    };
    let fnError = error => {
      console.error("Fail to update task", error);
    };
    let header = { ...this.GraphHeader };
    header["If-Match"] = etag;
    header["Prefer"] = "return=representation";
    let api =
      MIAPACons.GraphAPI.GraphBaseURL +
      (isbeta ? MIAPACons.GraphAPI.PlannerTaksbeta : MIAPACons.GraphAPI.PlannerTaks) +
      "/" +
      ID;

    GraphRequest.Patch(
      api,
      header,
      task,
      fnsuccess,
      fnError,
      this.ShowHideProgress
    );
  }
  private UpdateFlageEmail = (ID, task, col) => {
    let fnsuccess = response => {
      if (response.data) {
        let prevstate = { ...this.state };

        if (col <= 0) {
          prevstate.FlaggedEmail.Today = new Array();
        } else if (col == 1) {
          prevstate.FlaggedEmail.ThisWeek = new Array();
        } else {
          prevstate.FlaggedEmail.NextWeek = new Array();
        }
        this.ChangeState(prevstate);
        this.GetMyFlaggedEmails();
      }
    };
    let fnError = error => {
      console.error("Fail to update flagged email", error);
    };
    let header = { ...this.GraphHeader };
    //header["Prefer"] = 'outlook.timezone="' + Helper.getTimeZoneId() + '"';
    header["Prefer"] = 'outlook.timezone="' + this.usertimezone + '"';

    let api =
      MIAPACons.GraphAPI.GraphBaseURL +
      MIAPACons.GraphAPI.MyFlagEmails + '/' +
      ID;

    // "v1.0/messages/"
    GraphRequest.Patch(
      api,
      header,
      task,
      fnsuccess,
      fnError,
      this.ShowHideProgress
    );
  }
  private taskfromflagemail = (ID) => {
    let api =
      MIAPACons.GraphAPI.GraphBaseURL +
      MIAPACons.GraphAPI.MyFlagEmails + '/' +
      ID;
    GraphRequest.GET(api, this.GraphHeader, (result) => {
      this.flagemailfortask = result.data;
      this.shownewtaskwindow();
    }, (error) => { }, this.ShowHideProgress);

  }
  private PrepareCRMUser = () => {
    let userInfo = {
      SiteURL: this.appurl,
      UserName: this.email,
      AccessToken: this.sptoken
    };
    return userInfo;
  }
  private FilterColData = (col, selectedoptions) => {
    this.resetSearch();
    let colcprop = "ToDayCol";
    if (col == 1) {
      colcprop = "ThisWeekCol";
    } else if (col == 2) {
      colcprop = "NextWeekCol";
    }
    let prevstate = { ...this.state };
    if (selectedoptions) {
      prevstate[colcprop].currentselection = selectedoptions;
    } else {
      prevstate.Calview = col;
    }
    /*if (selectionindex < 6) {
      prevstate[colcprop].currentselection = selectionindex;     
    }
    else {
      prevstate.Calview = col;     
    }*/
    this.ChangeState(prevstate);
  }
  private SwithtoColview = (view, phrase) => {
    let prevstate = { ...this.state };
    prevstate.Calview = view;
    prevstate.activitytitle = Language.GetLanguageValue(this.culture, phrase);
    prevstate.showweekend = false;
    this.ChangeState(prevstate);
  }
  private ChangeState = newstate => {
    this.setState(newstate);
  }
  private ShowHideProgress = (value, src) => {
    /*if(this.RequestPending==0 && value<0){
      return;
    }*/
    //console.log('ShowHideProgress','value=',value,'src=',src);
    let show = false;
    this.RequestPending += value;
    if (this.RequestPending <= 0) {
      this.RequestPending = 0;
      if (this.ProgressIsShowing) {
        this.ProgressIsShowing = false;
      }
    } else //if (this.ProgressIsShowing == false) 
    {
      this.ProgressIsShowing = true;
      show = true;
    }
    //console.log('ShowHideProgress','this.RequestPending=',this.RequestPending,'show=',show);
    if (this.refloading && this.refloading.ShowHideLoading) {
      this.refloading.ShowHideLoading(show);
    }

    return;

    /* if (this.RequestPending <= 0) {
      this.RequestPending = 0;
      if (this.ProgressIsShowing) {
        this.setState({ isLoading: false });
        this.ProgressIsShowing = false;
      }
    } else if (this.ProgressIsShowing == false) {
      this.ProgressIsShowing = true;
      this.setState({ isLoading: true });
    } */

  }
  private quickSearch = () => {
    let mipaclass = "mipa";
    $("body").off("keyup", ".MIPAsearch");
    $("body").on("keyup", ".MIPAsearch", function () {
      let webparts = $(".webpart,.noteitem,.linkitem", $("." + mipaclass));
      var val = $(this).val();
      if (val) {
        val = val.toLowerCase();
      }
      if (val.length >= 2) {
        webparts.hide();
      } else {
        webparts.show();
        return;
      }
      webparts.each(function () {
        var body = $(this).html();
        var regex = /(<([^>]+)>)/gi;

        var words = body.replace(regex, "");
        if (words) {
          words = $.trim(words.replace(/\n/g, ""));
          if (words.toLocaleLowerCase().indexOf(val) < 0) {
            // $(this).hide();
          } else {
            $(this).show();
          }
        }
      });
    });
  };
  private resetSearch = () => {
    let mipaclass = "mipa";
    let webparts = $("[class^='webpart_']", $("." + mipaclass));
    webparts.show();
    $(".search").val("");
  }
  private shownewtaskwindow = () => {
    let prevstate = { ...this.state };
    prevstate.ShowMysettingWindow = false;
    prevstate.ShowNewPlanTaskWindow = true;
    this.ChangeState(prevstate);

  }
  private closeMysettingWindow = (reload) => {

    let prevstate = { ...this.state };
    prevstate.ShowMysettingWindow = false;
    if (reload) {
      /*prevstate.PlannerTask.Today = new Array();
      prevstate.PlannerTask.ThisWeek = new Array();
      prevstate.PlannerTask.NextWeek = new Array();*/
      this.ChangeState(prevstate);
      //this.GetPlannerTaks();
    } else {
      this.ChangeState(prevstate);
    }
  }
  private closePlantaskWindow = (reload: boolean, newTaskCreated: boolean = null) => {
    let prevstate = { ...this.state };
    prevstate.ShowNewPlanTaskWindow = false;
    if (reload) {
      prevstate.PlannerTask.Today = new Array();
      prevstate.PlannerTask.ThisWeek = new Array();
      prevstate.PlannerTask.NextWeek = new Array();
      prevstate.PlannerTask.Late = new Array();
      prevstate.PlannerTask.WithoutdueDate = new Array();
      this.ChangeState(prevstate);
      this.GetPlannerTaks(newTaskCreated);
    } else {
      this.ChangeState(prevstate);
    }
  }
  private PrepareLogtitle = () => {
    var currentdate = new Date();
    var minutes = currentdate.getMinutes();
    var hour = currentdate.getHours();
    var day = currentdate.getDate();
    var month = currentdate.getMonth() + 1;
    var year = currentdate.getFullYear();
    var datetime =
      day + "/" + month + "/" + year + " : " + hour + ":" + minutes + "\n";
    this.logtitle = this.username + " " + datetime;
  }
  private PrepareMeetingReportThumbForContacts = (meetings) => {
    if (meetings && meetings.length > 0) {
      return (
        <Reports
          meetings={meetings}
          UpdateMethod={this.UpdateCRMData}
          /* LogTitle={this.state.SSO.LogTitle} */
          LogTitle={this.logtitle}
          InsideCRM={!this.props.isteam}
          CRMURL={this.appurl}
          Phrases={this.MeetingReportPhrases}
          Progress={this.ShowHideProgress}
          meetingcontacts={this.MeetingContacts}
          forcontactcard={true}
          RefreshCRMData={this.RefreshCRMData}
        />
      );
    } else {
      return "";
    }
  }
  private PrepareCRMSSOUIThumbForContact = (ssolist) => {
    if (ssolist && ssolist.List && ssolist.List.length > 0) {
      return (
        <PipelineList
          Piplelines={ssolist.List}
          Phases={ssolist.Phases}
          Probability={ssolist.Probabilty}
          UpdateMethod={this.UpdateCRMData}
          /* LogTitle={this.state.SSO.LogTitle} */
          LogTitle={this.logtitle}
          InsideCRM={!this.props.isteam}
          CRMURL={this.appurl}
          Phrases={this.SSOPhrases}
          ssocontacts={this.SSOContacts}
          fotcontactrecent={true}
          RefreshCRMData={this.RefreshCRMData}
        />
      );
    } else {
      return "";
    }
  }
  private GetThumbnailImage = (api, fnsuccess) => {
    api = MIAPACons.GraphAPI.GraphBaseURL + api;
    GraphRequest.GET(api,
      this.GraphHeader,
      fnsuccess,
      (error) => {
        console.log("No thumbnail found for");
      },
      () => { });
  }
  private GetFilePreview = (api, fnsuccess) => {
    api = MIAPACons.GraphAPI.GraphBaseURL + api;
    GraphRequest.POST(api,
      this.GraphHeader,
      { page: 1, zoom: 2 },
      fnsuccess,
      (error) => {
        console.log("No preview found for");
      },
      this.ShowHideProgress);
  }
  private SaveO2SFileInfo = (fileino, fnSuccess, fnerror) => {
    /* if(this.email!='das@iglobe.dk'){
      return;
    } */
    fileino.UserEmail = this.email;
    var api = "/SaveO2SFileInfo";
    //fileino=JSON.stringify(fileino);
    let header = { ...this.APIHeader };
    // header['contentType']= "application/json; charset=utf-8";
    // header['Content-Type']= "application/json; charset=utf-8";
    this.SRequest.Post(
      this.APIServiceurl,
      api,
      fileino,
      (response) => {
        fnSuccess(response, this.O2SURL, this.email);
      },
      fnerror,
      this.ShowHideProgress,
      header
    );
  }
  private changeplan = (event, planid = '', fncallback = null) => {

    if (planid) {
      this.GetPlannerTaks(null, planid, fncallback);
    } else {
      if (event.target.value != this.currentplan) {
        this.currentplan = event.target.value;
        this.ResetPlannerView();
        this.GetPlannerTaks();
      }

      //return this.currentplan;
    }

  }
  public GetMIPAStickyNotes = (fnsuccess) => {
    this.ReadMIPAConfigFiles(fnsuccess, "StickyNote");
  }
  public SaveMIPAStickyNote = (noteobj, fordelete) => {
    var api =
      "/SaveMIPAStikcyNote";

    let configobj = {
      SiteURL: this.userSiteURL,
      UserEmail: this.email,
      ConfigType: "StickyNote"
    };
    var objRequest = {
      config: configobj,
      note: noteobj,
      delete: fordelete
    };
    this.SRequest.Post(
      this.APIServiceurl,
      api,
      objRequest,
      (successres) => {
        if (successres && successres.data && successres.data.IsSuccess) {

        }
      },
      (errorres) => {
        this.ShowHideProgress(-1, '');
        console.log(errorres);
      },
      this.ShowHideProgress,
      this.APIHeader
    );
  }
  public GetMIPALinks = (fnsuccess) => {
    this.ReadMIPAConfigFiles(fnsuccess, "Links");
  }
  public SaveMIPALinks = (linkbj, fordelete) => {
    var api =
      "/SaveMIPALinks";

    let configobj = {
      SiteURL: this.userSiteURL,
      UserEmail: this.email,
      ConfigType: "Links"
    };
    var objRequest = {
      config: configobj,
      link: linkbj,
      delete: fordelete
    };
    this.SRequest.Post(
      this.APIServiceurl,
      api,
      objRequest,
      (successres) => {
        if (successres && successres.data && successres.data.IsSuccess) {

        }
      },
      (errorres) => {
        this.ShowHideProgress(-1, '');
        console.log(errorres);
      },
      this.ShowHideProgress,
      this.APIHeader
    );
  }
  public GetMIPALinksPrev = (url, fnsucess) => {
    var api = "/Preview?url=" + encodeURIComponent(url);

    this.SRequest.Get(
      this.APIServiceurl,
      api,
      null,
      (successres) => {
        fnsucess(successres.data)

      },
      (errorres) => {
        this.ShowHideProgress(-1, '');
        console.log(errorres);
      },
      this.ShowHideProgress
    );
  }
  public GoToHome = () => {
    this.state.Dashboard = 1;
    this.SwithtoColview(0, "useractivity");
  };
  public SetIsMyTask = (isMyTask: boolean) => {
    this.IsMyTask = isMyTask;
  };
  public SetSelectedPlanItems = (selectedplanItems: String[]) => {
    this.SelectedPlanList = selectedplanItems;
  };
  public GetAPIHeader=()=>{
    return this.APIHeader
  }
}
